import React, { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import ShopifyConfiguration from "../setup/shopifyConfiguration";
import WordPressConfiguration from "../setup/wordPressConfiguration";
import WebConfiguration from "../setup/webConfiguration";
import moment from "moment-timezone";
import Flatpickr from "react-flatpickr";
import "./../Analytics/stylesAnalytics.scss";
import {
  Card,
  CardBody,
  CardTitle,
  Col,
  Container,
  Form,
  FormGroup,
  Input,
  Label,
  Row,
  TabContent,
  TabPane,
  NavLink,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Spinner,
  Dropdown,
  DropdownMenu,
  DropdownItem,
  DropdownToggle,
  ButtonDropdown,
  InputGroup,
  Badge,
  InputGroupText,
  Tooltip,
  FormFeedback,
  Alert,
  UncontrolledTooltip
} from "reactstrap";
import classnames from "classnames";
import getFrenchTag from "../../helpers/local_text_helper";
import axios from "axios";
import backgroundImage from "../../assets/images/onboardingBG.png";
import { Client, Databases, Query, Functions, ExecutionMethod } from "appwrite";
import bot_info_icon from "../../assets/images/bot-info.png";
import synibox_logo from "../../assets/images/companies/img-3.png";
import synibox_chat_logo_1000 from "../../assets/images/companies/img-7.png";
import synibix_icon_buble_chat from "../../assets/images/companies/synibix_icon_buble_chat.png";

import Select from "react-select";
import makeAnimated from "react-select/animated";
import {
  getUser,
  shopifyOauth,
  updateUserPrefs,
  createLog,
  updateAgentFunctionExecution,
  klaviyoUpdateProfile
} from "../../helpers/api_helper";

// slider
import MultiRangeSlider from "multi-range-slider-react";

// flags
import usFlag from "../../assets/images/flags/us.png";
import spain from "../../assets/images/flags/spain.png";
import french from "../../assets/images/flags/french.png";
import china from "../../assets/images/flags/china.png";
import germany from "../../assets/images/flags/germany.png";
import italy from "../../assets/images/flags/italy.png";
import japan from "../../assets/images/flags/japan.png";
import portugal from "../../assets/images/flags/portugal.png";
import russia from "../../assets/images/flags/russia.png";
import south_korea from "../../assets/images/flags/south-korea.png";
import { first, map } from "lodash";

import { withTranslation } from "react-i18next";
import LanguageDropdown from "../../components/Common/TopbarDropdown/LanguageDropdown";
import StaticData from "../../static/data";
import CheckCircleMono from "../../assets/images/icons/CheckCircleMono";
// Formik validation
import * as Yup from "yup";
import { useFormik } from "formik";
import tagDescriptions from "../setup/tagDescriptions";
import InfoMono from "../../assets/images/icons/InfoMono";
import { useDispatch, useSelector } from "react-redux";
import CalculatorModal from "../../components/Common/CalculatorModal/CalculatorModal";
import { fetchUserSubscription } from "../../store/subscription/actions";
import AlertTriangeMono from "../../assets/images/icons/AlertTriangeMono";
import CheckCircleRounded from "../../assets/images/icons/CheckCircleRounded";
import CreatableSelect from "react-select/creatable";
import MaaiaChangeStatus from "../../components/Common/MaaiaChangeStatus";

import aiBehaviorData from "../../CommonData/Data/aiBehavior";
import MyCustomSwitch from "../../components/Common/MyCustomSwitch";
import { useMixpanel } from "../../Hooks/useMixpanel";
import CustomToast from "../../components/Common/customToast/CustomToast";
import Slider from "rc-slider";
import "../../assets/css/rc-slider-style.css";
import { applyConsumedCredit, fetchClientInfos } from "../../store/actions";
import MdiInformationVariantCircle from "../../assets/images/icons/MdiInformationVariantCircle";

const languages = [
  {
    label: "Anglais",
    code: "en",
    flag: usFlag
  },
  {
    label: "Espagnol",
    code: "sp",
    flag: spain
  },
  {
    label: "Français",
    code: "fr",
    flag: french
  },
  {
    label: "Chinese",
    code: "zh",
    flag: china
  },
  {
    label: "German",
    code: "de",
    flag: germany
  },
  {
    label: "Portuguese",
    code: "pt",
    flag: portugal
  },
  {
    label: "Japanese",
    code: "ja",
    flag: japan
  },
  {
    label: "Russian",
    code: "ru",
    flag: russia
  },
  {
    label: "Italian",
    code: "it",
    flag: italy
  },
  {
    label: "Korean",
    code: "ko",
    flag: south_korea
  }
];

const greetings = [
  {
    label_fr: "Bonjour",
    label_en: "Good morning"
  },
  {
    label_fr: "Bonsoir",
    label_en: "Good evening"
  }
  // ,
  // {
  //   label_fr: "Comment vous allez ?",
  //   label_en: "How are you?"
  // }
];

const formulas = [
  {
    label_fr: "Excellente journée",
    label_en: "Excellent day"
  },
  {
    label_fr: "Bonne journée",
    label_en: "Good day"
  },
  {
    label_fr: "Excellente soirée",
    label_en: "Excellent evening"
  },
  {
    label_fr: "Bonne soirée",
    label_en: "Good evening"
  }
];

const tones = ["Formal", "Informal", "Friendly", "Professional"];

const delais = ["< 5min", "15min", "30min", "1H"];

const components = {
  DropdownIndicator: null
};

const createOption = (label) => ({
  label,
  value: label
});

const MaaiaPage = (props) => {
  const { mixPanelTrack } = useMixpanel();
  const [activeTab, setactiveTab] = useState(1);
  const [componentToRender, setComponentToRender] = useState(undefined);
  const [activeTabwiz, setoggleTabwiz] = useState(1);
  const [passedSteps, setPassedSteps] = useState([1]);
  const [passedStepswiz, setpassedStepswiz] = useState([1]);
  const [isMonoProductStore, setswitch1] = useState(false);
  const [fullTime, setFullTime] = useState({ week: true, week_end: true });
  const [tooltip, setTooltip] = useState(false);
  const [tooltip2, setTooltip2] = useState(false);
  const [updateAgentLoading, setUpdateAgentLoading] = useState(false);
  const [isDataLoaded, setIsDataLoaded] = useState(false);

  const [aiPowerDetails, setAiPowerDetails] = useState({
    0: {
      title: "aiPowerDetails_0_title",
      ai_tasks: "aiPowerDetails_0_ai_tasks",
      human_tasks: "aiPowerDetails_0_human_tasks",
      selectedTagNameList: []
    },
    30: {
      title: "aiPowerDetails_30_title",
      ai_tasks: "aiPowerDetails_30_ai_tasks",
      human_tasks: "aiPowerDetails_30_human_tasks",
      selectedTagNameList: [
        {
          label: "product",
          description: tagDescriptions["product"]
        },
        { label: "order", description: tagDescriptions["order"] },
        { label: "feedback", description: tagDescriptions["feedback"] },
        { label: "returns", description: tagDescriptions["returns"] },
        { label: "delivery", description: tagDescriptions["delivery"] }
      ]
    },
    60: {
      title: "aiPowerDetails_60_title",
      ai_tasks: "aiPowerDetails_60_ai_tasks",
      human_tasks: "aiPowerDetails_60_human_tasks",
      selectedTagNameList: [
        {
          label: "product",
          description: tagDescriptions["product"]
        },
        { label: "order", description: tagDescriptions["order"] },
        { label: "feedback", description: tagDescriptions["feedback"] },
        { label: "returns", description: tagDescriptions["returns"] },
        { label: "delivery", description: tagDescriptions["delivery"] },
        { label: "refunds", description: tagDescriptions["refunds"] },
        { label: "payments", description: tagDescriptions["payments"] }
        //  { label: "cancellations", description: tagDescriptions["cancellations"] }
      ]
    },
    // 70: {
    //   title: "aiPowerDetails_70_title",
    //   ai_tasks: "aiPowerDetails_70_ai_tasks",
    //   human_tasks: "aiPowerDetails_70_human_tasks",
    //   selectedTagNameList: [
    //     {
    //       label: "product",
    //       description: tagDescriptions["product"],
    //     },
    //     { label: "order", description: tagDescriptions["order"] },
    //     { label: "feedback", description: tagDescriptions["feedback"] },
    //     { label: "returns", description: tagDescriptions["returns"] },
    //     { label: "delivery", description: tagDescriptions["delivery"] },
    //     { label: "refunds", description: tagDescriptions["refunds"] },
    //     { label: "payments", description: tagDescriptions["payments"] },
    //     { label: "cancellations", description: tagDescriptions["cancellations"] },
    //     { label: "customer_account", description: tagDescriptions["customer_account"] },
    //     { label: "company_information", description: tagDescriptions["company_information"] },
    //   ],
    // },
    90: {
      title: "aiPowerDetails_90_title",
      ai_tasks: "aiPowerDetails_90_ai_tasks",
      human_tasks: "aiPowerDetails_90_human_tasks",
      selectedTagNameList: [
        {
          label: "product",
          description: tagDescriptions["product"]
        },
        { label: "order", description: tagDescriptions["order"] },
        { label: "feedback", description: tagDescriptions["feedback"] },
        { label: "returns", description: tagDescriptions["returns"] },
        { label: "delivery", description: tagDescriptions["delivery"] },
        { label: "refunds", description: tagDescriptions["refunds"] },
        { label: "payments", description: tagDescriptions["payments"] },
        //   { label: "cancellations", description: tagDescriptions["cancellations"] },
        {
          label: "customer_account",
          description: tagDescriptions["customer_account"]
        },
        {
          label: "company_information",
          description: tagDescriptions["company_information"]
        },
        { label: "influencers", description: tagDescriptions["influencers"] },
        {
          label: "customer_loyalty",
          description: tagDescriptions["customer_loyalty"]
        }
      ]
    }
  });
  // const tagsList = StaticData.tagsList

  const [modal_list, setmodal_list] = useState(false);
  const [modalInfo, setModalInfo] = useState({
    agent_work_times: {},
    agent_name: "",
    // agent_alias: '',
    agent_language: ""
  });

  const [expandedItems, setExpandedItems] = useState([]);
  const [mainProduct, setAsMainProduct] = useState(undefined);
  const [mailboxError, setMailboxError] = useState(undefined);
  const [whoisError, setWhoisError] = useState(undefined);
  // const selectedTagNameList = [];
  const [selectedTagNameList, setSelectedTagNameList] = useState([]);

  const [shopify_store_url, setShopifyStoreUrl] = useState("");
  const [shopify_token, setShopifyStoreToken] = useState("");
  const [Connected, setConnected] = useState(false);
  const [the_error, setThe_error] = useState("");
  const [productFetchError, setProductFetchError] = useState("");
  const [loading, setLoading] = useState(false);
  const [product_loading, setProductLoading] = useState(false);
  const [saveAllConfigLoading, setSaveAllConfigLoading] = useState(false);

  const [ordersData, setOrdersData] = useState({});
  const [productsCount, setProductsData] = useState({});
  const [couponCount, setCouponCount] = useState(0);
  const [host, setHost] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [port, setPort] = useState("");
  const [selectedServer, setSelectedServer] = useState("custom");
  const [selectedCms, setSelectedCms] = useState("Shopify");
  const [client_data, setCompanyInfos] = useState(undefined);
  const [site_name, setSiteName] = useState("");
  const [site_url, setSiteUrl] = useState("");
  const [site_infos_more, setSiteInfosMore] = useState("");
  const [smtp_host, setSMTPHost] = useState("");
  const [smtp_port, setSMTPPort] = useState("");
  const [tls_mode, setTlsMode] = useState();
  const [auto_response_level, setAutoResponseLevel] = useState(5);
  const [contactReasonValues, setContactReasonValues] = useState({});
  const [agentData, setagentData] = useState([]);
  const [autoMailBoxConfigs, setAutoMailBoxConfigs] = useState(true);
  const [isEmailValidation, setIsEmailValidation] = useState(false);
  const [toast, setToast] = useState(false);

  const [agent, setAgent] = useState({
    agent_name: ""
    // alias: ''
  });

  const [nameInputTouched, setNameInputTouched] = useState(false);

  const [cmsDropdown, setCmsDropdown] = useState(false);
  const [agentSelectedTimezone, setAgentTimezone] = useState("");
  const daysOfWeek = ["week", "week_end"];
  const timezones = moment.tz.names();
  const [marginPolite, setMarginPolite] = useState(
    localStorage.getItem("I18N_LANGUAGE") === "en" ? "20px" : "10px"
  );
  const [timesByDay, setTimesByDay] = useState({
    week: {
      open: 0,
      close: 24
    },
    week_end: {
      open: 0,
      close: 24
    }
  });
  const [marks, setMarks] = useState({
    week: { 0: "0h", 24: "23h59" },
    week_end: { 0: "0h", 24: "2h59" }
  });
  const navigate = useNavigate();

  const [selectedAgentLanguages, setSelectedAgentLanguages] = useState([]);
  const animatedComponents = makeAnimated();
  const animated2Components = makeAnimated();
  const animated3Components = makeAnimated();

  const [hoverText, setHoverText] = useState([]);
  const [toneSelected, setToneSelected] = useState(null);
  const [delaiSelected, setDelaiSelected] = useState(undefined);
  const [selectedGreeting, setSelectedGreeting] = useState([]);
  const [selectedFormula, setSelectedFormula] = useState([]);
  const [mailConnected, setMailConnected] = useState(false);

  const [maaiaNames, setMaaiaNames] = useState([]);
  const [inputValue, setInputValue] = useState("");
  const [placeholder, setPlaceholder] = useState(
    props.t("Donnez un nom à Synibox")
  );
  const [ai_behavior, setAiBehavior] = useState({
    can_respond_to_thanks: false
  });

  const [updateUserPrefsLoading, setUpdateUserPrefsLoading] = useState({
    loading: false,
    title: "",
    message: ""
  });

  // const { client_data } = useSelector((state) => {
  //   return {
  //     client_data: state.GeneralStateRedux.client_data
  //   };
  // });

  const onLoading = (val) => {
    setLoading(val);
  };

  const onProductLoading = (val) => {
    setProductLoading(val);
  };

  const onSaveAllConfigLoading = (val) => {
    setSaveAllConfigLoading(val);
  };

  const onCouponCountChange = (val) => {
    setCouponCount(val);
  };

  const fetchData = async (url, shopify_store_url, shopify_api_key) => {
    onLoading(true);

    const baseUrl = `http://ai.semecloud.tech:50000${url}`;
    try {
      const response = await axios.get(baseUrl, {
        params: {
          shopify_api_key,
          shopify_store_url
        }
      });
      onLoading(false);
      return response;
    } catch (error) {
      onLoading(false);
      console.error("Error", error);
      throw error;
    }
  };

  const fetchProductsCount = async (shopify_url, token) => {
    try {
      const url = "/shopify/product-count";
      const response = await fetchData(url, shopify_url, token);
      if (response.count) {
        setProductsData(response);
        setConnected(true);
        fetchOrdersData(shopify_url, token);
        fetchCouponsCount(shopify_url, token);
      } else {
        setThe_error(
          "Échec. Veuillez vérifier votre saisie ou les autorisations de votre clé API"
        );
      }
    } catch (error) {
      console.log("Error response", error.response);
      if (error.message && error.message.includes("404")) {
        setThe_error("URL incorrect. Veuillez vérifier votre saisie.");
      } else if (error.message && error.message.includes("401")) {
        setThe_error(
          "Clé API incorrecte. Veuillez vérifier votre saisie ou les autorisations de votre clé API"
        );
      } else {
        setThe_error(
          "Échec. Veuillez vérifier votre saisie ou les autorisations de votre clé API"
        );
      }
    }
  };

  const fetchCouponsCount = async (shopify_store_url, shopify_token) => {
    try {
      const url = "/shopify/coupon-count";
      const response = await fetchData(url, shopify_store_url, shopify_token);
      if (response.count) {
        onCouponCountChange(response.count);
      } else {
        setThe_error("Échec de chargement des coupons");
      }

      onProductLoading(false);
    } catch (error) {
      console.log("Error response", error.response);
      if (error.message && error.message.includes("404")) {
        setThe_error("Échec de chargement des coupons");
      } else if (error.message && error.message.includes("401")) {
        setThe_error("Échec de chargement des coupons");
      } else {
        setThe_error("Échec de chargement des coupons");
      }
      onProductLoading(false);
    }
  };

  const fetchOrdersData = async (shopify_store_url, shopify_token) => {
    try {
      const url = "/shopify/order-count";
      const response = await fetchData(url, shopify_store_url, shopify_token);
      setOrdersData(response);
      setThe_error("");
      //   toggleTabwiz(4);
    } catch (error) {
      if (error.message && error.message.includes("404")) {
        setThe_error("URL incorrect. Veuillez vérifier votre saisie.");
      } else if (error.message && error.message.includes("401")) {
        setThe_error(
          "Clé API incorrecte. Veuillez vérifier votre saisie ou les autorisations de votre clé API"
        );
      } else {
        setThe_error(
          "Échec. Veuillez vérifier votre saisie ou les autorisations de votre clé API"
        );
      }
    }
  };
  function toggleTab(tab) {
    if (activeTab !== tab) {
      var modifiedSteps = [...passedSteps, tab];
      if (tab >= 1 && tab <= 5) {
        setactiveTab(tab);
        setPassedSteps(modifiedSteps);
      }
    }
  }

  function toggleTabwiz(tab) {
    if (activeTabwiz !== tab) {
      var modifiedSteps = [...passedStepswiz, tab];
      if (tab >= 1 && tab <= 6) {
        setoggleTabwiz(tab);
        setpassedStepswiz(modifiedSteps);
      }
    }
  }

  function getSelectedSource(index) {
    switch (index) {
      case "Shopify":
        onSetComponentToRender(<ShopifyConfiguration />);
        break;
      case "WordPress":
        onSetComponentToRender(<WordPressConfiguration />);
        break;
      case "Website":
        onSetComponentToRender(<WebConfiguration />);
        break;
      default:
        onSetComponentToRender(<div> </div>);
        break;
    }
    const tab = 3;
    if (activeTabwiz !== tab) {
      var modifiedSteps = [...passedStepswiz, tab];
      if (tab >= 1 && tab <= 4) {
        setoggleTabwiz(tab);
        setpassedStepswiz(modifiedSteps);
      }
    }
  }

  const onSetComponentToRender = (value) => {
    setComponentToRender(value);
    toggleTabwiz(2);
  };

  const publicDomains = [
    "gmail.com",
    "yahoo.com",
    "hotmail.com",
    "outlook.com",
    "yahoo.fr",
    "aol.com",
    "icloud.com",
    "protonmail.com",
    "zoho.com",
    "yandex.com",
    "mail.com",
    "gmx.com",
    "fastmail.com",
    "tutanota.com",
    "mail.ru",
    "hushmail.com",
    "airmail.net",
    "lycos.com",
    "netcourrier.com",
    "zimbra.com",
    "rediffmail.com",
    "mailinator.com"
  ];

  const onSelectedServerChanged = (val) => {
    setSelectedServer(val);
  };

  const namesToArray = (names) => {
    if (Array.isArray(names)) {
      const res = names.map((name) => {
        return { label: name, value: name };
      });
      return res;
    }
    return [{ label: names, value: names }];
  };

  const loadMaaiaInfo = async function () {
    console.log("loadMaaiaInfo");

    if (client_data) {
      // if (selectedAgentLanguages.length === 0) {
      console.log({ maaiaPageCompanyInfo: client_data });
      const agentsList = client_data.agents;

      setDelaiSelected(
        !client_data.email_treatment_interval
          ? "< 5min"
          : client_data.email_treatment_interval === 5
          ? "< 5min"
          : client_data.email_treatment_interval === 15
          ? "15min"
          : client_data.email_treatment_interval === 30
          ? "30min"
          : "1H"
      );

      setAiBehavior((prev) => {
        const updatedStates = { ...prev };
        updatedStates["reply_to_thank_messages"] =
          client_data.reply_to_thank_messages;
        updatedStates["move_treated_emails"] = client_data.move_treated_emails;
        return updatedStates;
      });
      const agents = agentsList.map((element) => JSON.parse(element));
      console.log("agents is", agents);
      const first_agent = agents[0];
      setagentData(agents);
      if (first_agent) {
        setAgent(first_agent);
        const names = namesToArray(first_agent.agent_name);
        setMaaiaNames(names);
        // changeLanguageAction(first_agent.agent_language[0].code, first_agent.agent_language[0].name);
        setSelectedAgentLanguages(first_agent.agent_language ?? []);
        setAgentTimezone(first_agent.agent_timezone);
        setSelectedGreeting(first_agent.agent_greeting ?? []);
        setSelectedFormula(first_agent.agent_polite_formula ?? []);
        setToneSelected(first_agent.agent_tone_communication);
        if (first_agent.agent_work_times) {
          fecthTimesByDays(first_agent.agent_work_times);
          fecthFullTime(first_agent.agent_work_times);
        }
        setIsDataLoaded(true);
      }
      //   }
    }
  };

  const getClientData = async function () {
    const client = new Client();

    const databases = new Databases(client, "default");

    client
      .setEndpoint(process.env.REACT_APP_DATABASEURL)
      .setProject(process.env.REACT_APP_PROJECTID);

    const promise = databases.getDocument(
      "default",
      "client_infos",
      localStorage.getItem("companyId")
    );

    promise.then(
      function (response) {
        setCompanyInfos(response);
        setSelectedTagNameList(response.contact_reasons ?? []);
        return response;
      },
      function (error) {
        console.log(error); // Failure
        return null;
      }
    );
  };

  function setUtc(timezone) {
    const timeutc = moment.tz(timezone).utcOffset() / 60;
    const optionText = `${timezone} (UTC${timeutc >= 0 ? "+" : ""}${timeutc})`;
    return optionText;
  }

  async function updateCompanyInfos(data) {
    const client = new Client();

    const databases = new Databases(client, "default");

    client
      .setEndpoint(process.env.REACT_APP_DATABASEURL)
      .setProject(process.env.REACT_APP_PROJECTID);

    const promise = databases.updateDocument(
      "default",
      "client_infos",
      localStorage.getItem("companyId"),
      data
    );

    return await promise.then(
      async function (response) {
        console.log({ updateCompanyInfos: response });
        applyConsumedCredit(response.consumed_email_count, response);
        dispatch(fetchClientInfos());
        setCompanyInfos(response);
        return response;
      },
      function (error) {
        console.log(error);
        return undefined;
      }
    );
  }

  async function shopifyStoreUrlVerification() {
    const client = new Client();

    const databases = new Databases(client, "default");

    client
      .setEndpoint(process.env.REACT_APP_DATABASEURL)
      .setProject(process.env.REACT_APP_PROJECTID);

    try {
      const response = await databases.listDocuments(
        "default",
        "client_infos",
        [Query.equal("shopify_store_url", shopify_store_url)]
      );

      const company_id = localStorage.getItem("companyId");
      let urlAlreadyExist;

      if (response.total > 0) {
        urlAlreadyExist = true;
        const client_infos = response.documents;
        for (let index = 0; index < client_infos.length; index++) {
          const client_info = client_infos[index];
          if (client_info.$id === company_id) {
            urlAlreadyExist = false;
            break;
          }
        }
      } else {
        urlAlreadyExist = false;
      }
      return urlAlreadyExist;
    } catch (error) {
      console.log(error);
      return undefined;
    }
  }

  async function savEmailVerification() {
    const client = new Client();

    const databases = new Databases(client, "default");

    client
      .setEndpoint(process.env.REACT_APP_DATABASEURL)
      .setProject(process.env.REACT_APP_PROJECTID);

    try {
      const response = await databases.listDocuments(
        "default",
        "client_infos",
        [Query.equal("email", email)]
      );

      const company_id = localStorage.getItem("companyId");
      let urlAlreadyExist;

      if (response.total > 0) {
        urlAlreadyExist = true;
        const client_infos = response.documents;
        for (let index = 0; index < client_infos.length; index++) {
          const client_info = client_infos[index];
          if (client_info.$id === company_id) {
            urlAlreadyExist = false;
            break;
          }
        }
      } else {
        urlAlreadyExist = false;
      }
      return urlAlreadyExist;
    } catch (error) {
      console.log(error);
      return undefined;
    }
  }

  async function shopifyAuthentication() {
    onLoadingChanged(true);
    await shopifyOauth(shopify_store_url);
    // onLoadingChanged(false);
  }

  const onLoadingChanged = (val) => {
    setLoading(val);
  };

  const dispatch = useDispatch();

  const { userPlan, isUserPlanActive, number_of_languages } = useSelector(
    (state) => ({
      userPlan: state.subscription.userPlan,
      isUserPlanActive: state.subscription.isUserPlanActive,
      number_of_languages: state.subscription.numberOfLanguages
    })
  );

  useEffect(() => {
    if (!isDataLoaded) {
      loadMaaiaInfo();
    }
  }, [client_data]);

  useEffect(() => {
    getClientData();
  }, []);

  // useEffect(() => {
  //   if (isUserPlanActive) {
  //     setNumberOfLanguages(number_of_languages);
  //   } else {
  //     setNumberOfLanguages(0);
  //   }
  // }, [isUserPlanActive, number_of_languages]);

  const [isPasswordHidden, setIsPasswordHidden] = useState(true);
  const togglePasswordVisibility = () => {
    setIsPasswordHidden(!isPasswordHidden);
  };

  const svgs = {
    info_icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="13"
        height="13"
        viewBox="0 0 512 512"
      >
        <path
          d="M256 48C141.1 48 48 141.1 48 256s93.1 208 208 208 208-93.1 208-208S370.9 48 256 48zm19 304h-38.2V207.9H275V352zm-19.1-159.8c-11.3 0-20.5-8.6-20.5-20s9.3-19.9 20.5-19.9c11.4 0 20.7 8.5 20.7 19.9s-9.3 20-20.7 20z"
          fill="currentColor"
        />
      </svg>
    ),
    wiz: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="171"
        height="164"
        viewBox="0 0 171 164"
        fill="none"
      >
        <g filter="url(#filter0_d_344_10705)">
          <path
            d="M133.5 66C133.5 66 121 111 82 111C57.1472 111 37 90.8528 37 66C37 41.1472 57.1472 21 82 21C124.5 21 133.5 66 133.5 66Z"
            fill="#563BFF"
          />
        </g>
        <defs>
          <filter
            id="filter0_d_344_10705"
            x="0"
            y="0"
            filterUnits="userSpaceOnUse"
            color-interpolation-filters="sRGB"
          >
            <feFlood flood-opacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy="16" />
            <feGaussianBlur stdDeviation="18.5" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0.337255 0 0 0 0 0.231373 0 0 0 0 1 0 0 0 0.26 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_344_10705"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_344_10705"
              result="shape"
            />
          </filter>
        </defs>
      </svg>
    ),
    close_icon: (
      <svg
        width="11"
        height="12"
        viewBox="0 0 11 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M7.36078 3.13406C7.5521 2.93171 7.89946 2.92198 8.10181 3.11331L8.4827 3.47345C8.69695 3.67602 8.69477 4.01213 8.50345 4.21448L6.88282 5.92849L8.59683 7.54912C8.81108 7.7517 8.80891 8.0878 8.61758 8.29015L8.25744 8.67104C8.05486 8.88529 7.73066 8.89437 7.51641 8.69179L5.8024 7.07116L4.18177 8.78517C3.97919 8.99942 3.65499 9.0085 3.44074 8.80592L3.05985 8.44578C2.8575 8.25446 2.83652 7.919 3.0391 7.70475L4.65973 5.99074L2.94572 4.37011C2.74337 4.17879 2.72239 3.84333 2.92497 3.62908L3.28511 3.24819C3.47643 3.04584 3.82379 3.03612 4.02614 3.22744L5.74015 4.84807L7.36078 3.13406Z"
          fill="#563BFF"
        />
      </svg>
    ),
    next_icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="8"
        height="13"
        viewBox="0 0 8 13"
        fill="none"
      >
        <path
          d="M0.956385 -0.000111687C1.20673 -0.0138366 1.40601 0.101453 1.58663 0.255722C2.38817 0.940139 3.18861 1.62584 3.98795 2.31282C5.18843 3.34127 6.38927 4.36936 7.59048 5.39709C8.12246 5.85001 8.14332 6.45171 7.61299 6.90683C5.77384 8.48539 3.93287 10.0608 2.09007 11.6332C1.89243 11.8022 1.69918 11.9763 1.4966 12.1393C1.07826 12.4753 0.520481 12.4232 0.197121 12.0246C-0.118553 11.6348 -0.0477319 11.0913 0.35688 10.7438C2.10013 9.25453 3.8432 7.76528 5.58609 6.27603C5.70467 6.17557 5.67008 6.13 5.57236 6.04655C3.86571 4.58842 2.15997 3.12899 0.45515 1.66829C0.151554 1.40917 -0.0274194 1.10722 0.0631653 0.698763C0.15924 0.267799 0.512246 -0.000111687 0.956385 -0.000111687Z"
          fill="#563BFF"
        />
      </svg>
    ),
    prev_icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="8"
        height="13"
        viewBox="0 0 8 13"
        fill="none"
      >
        <path
          d="M7.04361 12.3614C6.79327 12.3752 6.59399 12.2599 6.41337 12.1056C5.61183 11.4212 4.81139 10.7355 4.01205 10.0485C2.81157 9.02005 1.61073 7.99196 0.409523 6.96424C-0.122457 6.51132 -0.143319 5.90961 0.387013 5.4545C2.22616 3.87594 4.06713 2.3005 5.90993 0.728171C6.10757 0.55908 6.30082 0.385047 6.5034 0.221995C6.92174 -0.113992 7.47952 -0.0618377 7.80288 0.336735C8.11855 0.726524 8.04773 1.27003 7.64312 1.61755C5.89987 3.1068 4.1568 4.59604 2.41391 6.08529C2.29533 6.18576 2.32992 6.23133 2.42764 6.31477C4.13429 7.77291 5.84003 9.23233 7.54485 10.693C7.84845 10.9522 8.02742 11.2541 7.93683 11.6626C7.84076 12.0935 7.48775 12.3614 7.04361 12.3614Z"
          fill="currentColor"
        />
      </svg>
    ),
    plus_icon: (
      <svg
        width="15"
        height="15"
        viewBox="0 0 15 15"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M7.4 14.104C6.98933 14.104 6.672 13.992 6.448 13.768C6.224 13.5253 6.112 13.1987 6.112 12.788V8.196H1.604C1.212 8.196 0.904 8.09333 0.68 7.888C0.456 7.664 0.344 7.356 0.344 6.964C0.344 6.572 0.456 6.27333 0.68 6.068C0.904 5.844 1.212 5.732 1.604 5.732H6.112V1.28C6.112 0.869333 6.224 0.551999 6.448 0.327999C6.672 0.103999 6.99867 -0.00800037 7.428 -0.00800037C7.83867 -0.00800037 8.14667 0.103999 8.352 0.327999C8.576 0.551999 8.688 0.869333 8.688 1.28V5.732H13.196C13.6067 5.732 13.9147 5.844 14.12 6.068C14.344 6.27333 14.456 6.572 14.456 6.964C14.456 7.356 14.344 7.664 14.12 7.888C13.9147 8.09333 13.6067 8.196 13.196 8.196H8.688V12.788C8.688 13.1987 8.576 13.5253 8.352 13.768C8.14667 13.992 7.82933 14.104 7.4 14.104Z"
          fill="white"
        />
      </svg>
    ),
    sale_box: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="72"
        height="73"
        viewBox="0 0 72 73"
        fill="none"
      >
        <path
          d="M33.075 52.8526C33.075 58.8401 33.075 64.8275 33.075 70.8401C33.075 72.1734 33 72.2489 31.775 71.6954C25.725 69.0036 19.7 66.3118 13.65 63.6199C11.625 62.7143 9.6 61.8338 7.575 60.903C2.65 58.6388 0.025 54.8149 0 49.3055C0 40.5759 0 31.8715 0 23.142C0 22.3369 0 21.5067 0.175 20.7017C0.425 19.5948 0.475 19.5193 1.5 19.9721C4.975 21.5319 8.45 23.0916 11.925 24.6514C17.9 27.3181 23.9 29.9847 29.875 32.6514C30.625 32.9784 31.375 33.2803 32.175 33.4564C32.925 33.6074 33.1 33.9847 33.1 34.6891C33.05 40.752 33.075 46.7898 33.075 52.8526Z"
          fill="#329993"
        />
        <path
          d="M38.9234 52.8274C38.9234 46.84 38.9484 40.8274 38.8984 34.84C38.8984 33.9344 39.1984 33.6073 40.0234 33.3557C43.4484 32.3494 46.5734 30.5884 49.8484 29.2048C51.8984 28.3243 51.5734 28.4249 51.5734 30.3369C51.5734 32.1482 51.5484 33.9847 51.5984 35.796C51.6234 37.1042 52.5484 38.2866 53.7234 38.5633C55.0234 38.8903 56.2984 38.362 56.9484 37.2299C57.2984 36.6513 57.2984 36.0476 57.2984 35.4186C57.2984 32.601 57.3234 29.7583 57.2984 26.9406C57.2984 26.1859 57.5484 25.7583 58.2484 25.4312C62.3234 23.645 66.3984 21.8086 70.4734 19.9721C71.5234 19.4941 71.5484 19.5444 71.7984 20.6765C71.9734 21.4564 71.9734 22.2362 71.9734 23.0161C71.9734 31.7708 71.9734 40.5255 71.9734 49.2803C71.9734 54.6639 69.4734 58.513 64.6484 60.752C57.6984 63.9469 50.6984 67.0161 43.7234 70.1356C42.4984 70.6891 41.2734 71.2425 40.0234 71.7457C39.0234 72.1482 38.8984 72.0727 38.8984 70.9658C38.9234 64.9532 38.9234 58.8903 38.9234 52.8274Z"
          fill="#329993"
        />
        <path
          d="M35.9742 0.0224498C37.6992 -0.0781791 39.2992 0.299179 40.8242 1.00358C48.7492 4.52559 56.6742 8.09792 64.5742 11.6199C65.7742 12.1482 66.8742 12.8526 67.8992 13.708C68.5242 14.2363 68.4742 14.513 67.7242 14.8401C64.2492 16.3746 60.6992 17.7835 57.3242 19.5445C55.2742 20.6011 53.6742 20.3746 51.6992 19.4187C42.2242 14.8401 32.6992 10.3872 23.1992 5.88408C22.8242 5.70798 22.1992 5.65767 22.1992 5.17968C22.1992 4.77717 22.8242 4.75201 23.1742 4.57591C25.7992 3.39352 28.3992 2.21113 31.0242 1.02874C32.5992 0.349494 34.2492 -0.103336 35.9742 0.0224498Z"
          fill="#329993"
        />
        <path
          d="M36.1012 28.1734C34.6012 28.1483 33.2262 27.7709 31.9012 27.1923C23.6012 23.469 15.3262 19.7457 7.02624 16.0476C6.05124 15.62 5.10124 15.1671 4.12624 14.7646C3.55124 14.513 3.52624 14.2615 3.97624 13.8338C4.95124 12.9281 6.05124 12.2489 7.25124 11.6954C9.47624 10.6891 11.7012 9.70801 13.9012 8.70172C14.4262 8.47531 14.8762 8.42499 15.4012 8.67657C25.6512 13.5319 35.9262 18.3873 46.2012 23.2426C46.4012 23.3432 46.6012 23.4439 46.7762 23.5445C47.1262 23.7206 47.1762 23.9722 46.8012 24.1231C43.4762 25.4816 40.4012 27.5193 36.7512 28.1231C36.5262 28.1734 36.2762 28.1483 36.1012 28.1734Z"
          fill="#329993"
        />
      </svg>
    ),
    check_list: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="55"
        height="73"
        viewBox="0 0 55 73"
        fill="none"
      >
        <path
          d="M28.3588 1.00002C30.2812 1.51041 31.9919 2.44319 32.8913 4.25595C33.4204 5.32952 34.0906 5.54072 35.1311 5.45272C36.1893 5.38232 37.2474 5.41752 38.3056 5.43512C39.7165 5.45272 40.6336 6.3679 40.6512 7.77587C40.6689 10.7502 40.6689 13.7245 40.6512 16.6989C40.6512 18.0716 39.7165 19.0044 38.3585 19.0044C30.8455 19.022 23.3502 19.022 15.8372 19.0044C14.4792 19.0044 13.5445 18.054 13.5445 16.6989C13.5268 13.7245 13.5268 10.7502 13.5445 7.77587C13.5445 6.3679 14.4792 5.45272 15.8901 5.43512C17.301 5.41752 18.7119 5.43512 20.1051 5.43512C20.3873 5.43512 20.6695 5.43512 20.8106 5.10073C21.7806 2.86558 23.5265 1.59841 25.8369 0.982422C26.6658 1.00002 27.5123 1.00002 28.3588 1.00002Z"
          fill="#329993"
        />
        <path
          d="M54.1782 41.4967C54.1782 50.4725 54.1782 59.4307 54.1782 68.4065C54.1782 70.6768 52.7673 72.4368 50.5981 72.912C50.2277 73 49.8574 73 49.487 73C34.5668 73 19.6467 73 4.70885 73C1.9047 73 0 71.0992 0 68.3185C0 50.4197 0 32.5385 0 14.6397C0 11.8589 1.92234 9.95816 4.69121 9.94056C5.90811 9.94056 7.125 9.95816 8.35953 9.92296C8.94152 9.90536 9.13552 10.099 9.13552 10.6797C9.10025 12.5277 9.10025 14.3757 9.13552 16.2236C9.15316 17.8604 9.50588 19.4268 10.564 20.7643C11.9926 22.6123 13.9502 23.4043 16.2076 23.4043C23.4737 23.4395 30.7574 23.4395 38.0235 23.4043C41.4626 23.3867 43.8787 21.5387 44.8134 18.3532C45.0251 17.6316 45.0603 16.8748 45.078 16.1356C45.0956 14.3053 45.0956 12.4749 45.078 10.6621C45.078 10.1166 45.2367 9.90536 45.8011 9.92296C47.0179 9.95816 48.2348 9.92296 49.4694 9.94056C52.3088 9.95816 54.1959 11.8237 54.1959 14.6573C54.1782 23.5979 54.1782 32.5385 54.1782 41.4967ZM15.8196 41.3911C16.4016 41.3383 16.9131 41.1799 17.3187 40.7927C20.3521 37.7655 23.3855 34.7384 26.4189 31.7113C26.5248 31.6057 26.5953 31.5001 26.6658 31.3769C27.4418 30.1449 26.7364 28.4905 25.3255 28.1562C24.3379 27.9274 23.6148 28.3674 22.9446 29.0361C20.7401 31.2361 18.5179 33.436 16.3311 35.6536C15.9431 36.0408 15.6962 36.076 15.3082 35.6712C14.4969 34.8264 13.668 33.9816 12.8038 33.2072C11.8338 32.3449 10.617 32.3977 9.77042 33.26C8.94152 34.1048 8.87098 35.3192 9.75278 36.2344C11.2342 37.8007 12.7862 39.2967 14.3205 40.8103C14.7438 41.1975 15.2729 41.3559 15.8196 41.3911ZM11.5164 50.5605C10.4053 50.5957 9.75278 51.018 9.36479 51.7748C8.95916 52.602 9.04734 53.4468 9.69988 54.1156C11.2342 55.6995 12.8038 57.2307 14.3735 58.7971C14.6204 59.0435 14.9378 59.2019 15.2905 59.2899C16.2429 59.5187 16.9836 59.1315 17.6361 58.4979C20.4756 55.6643 23.315 52.8308 26.1368 49.9973C26.2955 49.8389 26.4542 49.6453 26.5953 49.4693C27.5124 48.2021 26.8069 46.4422 25.2726 46.1254C24.3026 45.9142 23.5972 46.3717 22.9623 47.0053C20.793 49.1701 18.6061 51.3348 16.4545 53.5172C15.996 53.9924 15.6962 54.0628 15.22 53.5348C14.5322 52.778 13.7738 52.074 13.0331 51.3524C12.5569 50.8773 11.9926 50.5605 11.5164 50.5605ZM38.3233 36.9208C39.7695 36.9208 41.2333 36.956 42.6795 36.9032C44.0374 36.868 44.9898 35.9704 45.0251 34.7736C45.0603 33.5944 44.1256 32.5737 42.7853 32.5561C39.8224 32.5033 36.8772 32.5209 33.9143 32.5561C32.8032 32.5737 31.992 33.2424 31.7627 34.1576C31.3923 35.636 32.3976 36.868 34.0907 36.9208C35.5015 36.956 36.9124 36.9208 38.3233 36.9208ZM38.3233 54.9076C39.7695 54.9076 41.2333 54.9428 42.6795 54.89C44.0374 54.8548 44.9898 53.9572 45.0251 52.7604C45.0603 51.5812 44.1256 50.5605 42.7853 50.5429C39.8224 50.4901 36.8772 50.5077 33.9143 50.5429C32.8032 50.5605 31.992 51.2292 31.7627 52.1444C31.3923 53.6228 32.3976 54.8548 34.0907 54.9076C35.5015 54.9428 36.9124 54.9076 38.3233 54.9076Z"
          fill="#329993"
        />
      </svg>
    ),
    coupon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="64"
        height="88"
        viewBox="0 0 64 88"
        fill="none"
      >
        <path
          d="M63.1065 44.0562C63.1065 54.7938 63.1065 65.5313 63.1065 76.2688C63.1168 77.8127 62.8307 79.3434 62.2647 80.7718C61.6987 82.2001 60.8641 83.4977 59.8095 84.5888C58.7549 85.68 57.5013 86.5431 56.1217 87.1279C54.7421 87.7127 53.264 88.0075 51.7733 87.9951C47.9956 87.9951 44.2258 87.9951 40.4639 87.9951C38.0343 87.9951 36.3037 86.3028 36.1171 83.7815C35.9212 81.1501 34.7005 79.6876 32.3867 79.311C30.427 78.9907 28.3587 80.4678 27.9502 82.4902C27.8579 82.9682 27.7948 83.4517 27.7613 83.938C27.6868 85.0286 27.2191 86.0505 26.4511 86.8006C25.6831 87.5508 24.6709 87.9745 23.6153 87.9878C19.6975 88.0041 15.7805 88.0041 11.8643 87.9878C6.66996 87.9878 1.94783 83.9257 0.965627 78.6507C0.831926 77.9328 0.766287 77.203 0.769654 76.4718C0.769654 54.8125 0.769654 33.1533 0.769654 11.494C0.769654 5.26278 5.85539 0.0122277 11.8667 0C15.6648 0 19.4638 0 23.2635 0C25.8394 0 27.5323 1.6165 27.7495 4.25767C27.962 6.85482 29.1662 8.29524 31.4304 8.6743C32.4309 8.81839 33.4472 8.5681 34.278 7.97299C35.1088 7.37787 35.6935 6.48133 35.9164 5.46087C36.0062 4.9818 36.0677 4.4975 36.1006 4.01067C36.1897 2.93628 36.6598 1.93414 37.4202 1.19758C38.1806 0.46102 39.1774 0.0422303 40.2183 0.0220089C44.1644 0.00570534 48.1113 0.00570534 52.059 0.0220089C57.2227 0.0342365 61.9448 4.12561 62.9199 9.40062C63.055 10.1809 63.1175 10.9728 63.1065 11.7654C63.1033 22.5225 63.1033 33.2861 63.1065 44.0562ZM49.4406 27.9891C49.4406 26.803 48.8858 26.0987 47.8658 25.8713C46.9804 25.6732 46.3476 26.1158 45.7621 26.7297C35.6064 37.2536 25.4538 47.7743 15.3044 58.2917C15.1343 58.4586 14.9765 58.6385 14.8322 58.8297C14.5914 59.1414 14.4448 59.5198 14.4107 59.9174C14.3767 60.315 14.4568 60.7142 14.6409 61.0649C15.014 61.8304 15.6491 62.1189 16.4518 62.1263C17.2546 62.1336 17.8 61.6201 18.3265 61.0723L44.591 33.8437C45.9439 32.4424 47.2944 31.0362 48.652 29.6398C49.129 29.1483 49.4784 28.6078 49.4406 27.9891ZM48.8126 54.2981C48.881 50.4097 45.696 47.0765 41.8687 47.03C38.1075 46.9762 34.8776 50.3095 34.8658 54.2443C34.8713 56.1443 35.5987 57.9656 36.8906 59.3143C38.1826 60.6631 39.9353 61.4308 41.7695 61.4513C45.6629 61.4635 48.6261 58.4702 48.8079 54.2981H48.8126ZM22.0901 40.97C26.1983 40.7988 29.0316 37.5462 28.9938 33.6627C28.956 29.6765 25.719 26.4166 22.0074 26.5414C17.911 26.6759 15.0706 29.9088 15.1013 33.8364C15.1249 37.8153 18.3785 41.0385 22.0853 40.97H22.0901Z"
          fill="#329993"
        />
      </svg>
    ),
    check_icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="15"
        height="15"
        viewBox="0 0 21 15"
        fill="none"
      >
        <path
          d="M20.9949 2.0168C20.8615 2.5003 20.5279 2.84638 20.1842 3.18738C16.4077 6.92815 12.6313 10.674 8.86001 14.4199C8.44439 14.8321 7.96721 15.051 7.37201 14.9899C6.96153 14.9492 6.61775 14.7609 6.33041 14.4759C4.39089 12.5571 2.45136 10.6435 0.52723 8.71456C-0.334782 7.84934 -0.103886 6.5159 0.958235 5.99677C1.62014 5.67105 2.36927 5.81355 2.94394 6.38357C4.16512 7.59487 5.38631 8.80617 6.60749 10.0175C6.88456 10.2923 7.16164 10.562 7.43358 10.8369C7.53107 10.9387 7.60291 10.9387 7.7004 10.8369C7.9826 10.5468 8.2802 10.2618 8.56754 9.97166C11.7077 6.85689 14.853 3.73704 17.9932 0.622277C18.4088 0.210029 18.8758 -0.0444449 19.4863 0.00644996C20.1483 0.0624343 20.7383 0.520488 20.9333 1.15158C20.9538 1.20757 20.9795 1.26355 21 1.31954C20.9949 1.55365 20.9949 1.78268 20.9949 2.0168Z"
          fill="white"
        />
      </svg>
    ),
    edit_icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="15"
        height="15"
        viewBox="0 0 15 15"
        fill="none"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.1579 0.472603C10.4606 0.169995 10.8711 0 11.2991 0C11.7271 0 12.1376 0.169995 12.4403 0.472603L14.5274 2.55971C14.83 2.8624 15 3.2729 15 3.70091C15 4.12893 14.83 4.53942 14.5274 4.84212L13.2474 6.12215L8.87785 1.75263L10.1579 0.472603ZM7.73665 2.89384L0.472947 10.1575C0.170214 10.4602 9.14216e-05 10.8707 0 11.2987V13.3858C0 13.8139 0.170062 14.2245 0.472775 14.5272C0.775488 14.8299 1.18605 15 1.61416 15H3.70126C4.12932 14.9999 4.53982 14.8298 4.84247 14.5271L12.1062 7.26335L7.73665 2.89384Z"
          fill="white"
        />
      </svg>
    ),
    folder_icon: (
      <svg
        width="19"
        height="12"
        viewBox="0 0 19 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M16.4688 5C17.6562 5 18.375 6.3125 17.75 7.3125L15.25 11.3125C14.9688 11.75 14.5 12 14 12H1.5C0.65625 12 0 11.3438 0 10.5V1.5C0 0.6875 0.65625 0 1.5 0H6.5L8.5 2H13.5C14.3125 2 15 2.6875 15 3.5V5H16.4688ZM1.5 1.6875V9L3.4375 5.75C3.71875 5.28125 4.21875 5 4.75 5H13.5V3.6875C13.5 3.59375 13.4062 3.5 13.3125 3.5H7.875L5.875 1.5H1.6875C1.5625 1.5 1.5 1.59375 1.5 1.6875ZM14 10.5L16.5 6.5H4.65625L2.25 10.5H14Z"
          fill="#737791"
        />
      </svg>
    ),
    eye_icon: (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M3.58028 16C2.50382 14.5528 2 13.0245 2 12C2 9.5 5 4 12 4C19 4 22 9.5 22 12C22 14.5 19 20 12 20C10.0212 20 8.36209 19.5605 7 18.8735M15 12C15 13.6569 13.6569 15 12 15C10.3431 15 9 13.6569 9 12C9 10.3431 10.3431 9 12 9C13.6569 9 15 10.3431 15 12Z"
          stroke="#2F384C"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
    eye_slash_icon: (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M3 3L5.82578 5.82578M21 21L18.1742 18.1742M18.1742 18.1742C16.6292 19.2482 14.588 20 12 20C10.1455 20 8.57181 19.614 7.26022 19M18.1742 18.1742L14.1213 14.1213M5.82578 5.82578C3.19179 7.65676 2 10.4243 2 12C2 13.0245 2.50382 14.5528 3.58028 16M5.82578 5.82578L9.87863 9.87863M9.87863 9.87863C9.33571 10.4215 8.99991 11.1715 8.99991 12C8.99991 13.6569 10.3431 15 11.9999 15C12.8284 15 13.5784 14.6642 14.1213 14.1213M9.87863 9.87863L14.1213 14.1213M20.4197 16C20.5431 15.8341 20.659 15.6671 20.7674 15.5C21.6051 14.2091 22 12.9071 22 12C22 9.5 19 4 12 4C10.903 4 9.90427 4.13507 8.99991 4.3725C8.82995 4.41712 8.66332 4.46536 8.5 4.517"
          stroke="#2F384C"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
    shopify_icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 256 292"
      >
        <path
          fill="#95BF46"
          d="M223.774 57.34c-.201-1.46-1.48-2.268-2.537-2.357a19614 19614 0 0 0-23.383-1.743s-15.507-15.395-17.209-17.099c-1.703-1.703-5.029-1.185-6.32-.805c-.19.056-3.388 1.043-8.678 2.68c-5.18-14.906-14.322-28.604-30.405-28.604c-.444 0-.901.018-1.358.044C129.31 3.407 123.644.779 118.75.779c-37.465 0-55.364 46.835-60.976 70.635c-14.558 4.511-24.9 7.718-26.221 8.133c-8.126 2.549-8.383 2.805-9.45 10.462C21.3 95.806.038 260.235.038 260.235l165.678 31.042l89.77-19.42S223.973 58.8 223.775 57.34M156.49 40.848l-14.019 4.339c.005-.988.01-1.96.01-3.023c0-9.264-1.286-16.723-3.349-22.636c8.287 1.04 13.806 10.469 17.358 21.32m-27.638-19.483c2.304 5.773 3.802 14.058 3.802 25.238c0 .572-.005 1.095-.01 1.624c-9.117 2.824-19.024 5.89-28.953 8.966c5.575-21.516 16.025-31.908 25.161-35.828m-11.131-10.537c1.617 0 3.246.549 4.805 1.622c-12.007 5.65-24.877 19.88-30.312 48.297l-22.886 7.088C75.694 46.16 90.81 10.828 117.72 10.828"
        />
        <path
          fill="#5E8E3E"
          d="M221.237 54.983a19614 19614 0 0 0-23.383-1.743s-15.507-15.395-17.209-17.099c-.637-.634-1.496-.959-2.394-1.099l-12.527 256.233l89.762-19.418S223.972 58.8 223.774 57.34c-.201-1.46-1.48-2.268-2.537-2.357"
        />
        <path
          fill="#FFF"
          d="m135.242 104.585l-11.069 32.926s-9.698-5.176-21.586-5.176c-17.428 0-18.305 10.937-18.305 13.693c0 15.038 39.2 20.8 39.2 56.024c0 27.713-17.577 45.558-41.277 45.558c-28.44 0-42.984-17.7-42.984-17.7l7.615-25.16s14.95 12.835 27.565 12.835c8.243 0 11.596-6.49 11.596-11.232c0-19.616-32.16-20.491-32.16-52.724c0-27.129 19.472-53.382 58.778-53.382c15.145 0 22.627 4.338 22.627 4.338"
        />
      </svg>
    ),
    woocommerce_icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 128 128"
      >
        <path
          fill="#7f54b3"
          d="M116.3 89.1H11.7C5.2 89.1 0 83.9 0 77.4v-40C0 31 5.2 25.8 11.7 25.8h104.7c6.4 0 11.7 5.2 11.7 11.7v40c-.1 6.4-5.3 11.6-11.8 11.6"
        />
        <path
          fill="#FFF"
          d="M13.8 76.7s2.8 11.8 8.5 3.9s11.2-20.3 11.2-20.3s.4-3.1 2 3.7S44 80 44 80s6.3 7.9 8.9-.4c-1-11 2.8-31 6.7-40.6c1.6-8.5-7.3-6.1-8.1-4.1s-6.3 14.8-6.7 28.2c0 0-4.7-12.8-5.1-17.4c-.4-4.7-5.3-5.9-8.1-1.4S20.3 66.2 20.3 66.2l-5.5-28.4s-5.5-7.3-8.7 1.6c0 0 5.7 34.9 7.7 37.3m73.2-31c-8.5-14.2-21.1-3.4-21.1-3.4s-9.6 11.1-5.3 26.2c6.9 14.9 16.6 8.3 19.2 7.1c2.7-1.3 14.1-14.3 7.2-29.9m-6.5 12.5c0 5.9-4.9 11.4-8.9 10.2c-2.2-1.3-3.6-4.8-3.6-10.8c2-9.7 6.4-11 8.7-10.8c4.3 2.3 4.1 7.4 3.8 11.4m38.4-12.5c-8.5-14.2-21.1-3.4-21.1-3.4s-9.6 11.1-5.3 26.2c6.9 14.9 16.6 8.3 19.2 7.1c2.6-1.3 14.1-14.3 7.2-29.9m-6.5 12.5c0 5.9-4.9 11.4-8.9 10.2c-2.2-1.3-3.6-4.8-3.6-10.8c2-9.7 6.4-11 8.7-10.8c4.2 2.3 4 7.4 3.8 11.4"
        />
        <path fill="#7f54b3" d="m61.3 89.1l22.3 13.1l-4.7-13.1l-12.8-3.6z" />
      </svg>
    ),
    magento_icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 128 128"
      >
        <path
          fill="#f26322"
          d="M119.82 31.97v64.01l-15.85 9.12V41.17l-39.62-22.9l-39.64 22.9l.1 63.96l-15.82-9.15V32.02L64.45 0zM72.3 105.1l-7.9 4.6l-7.95-4.55V41.17l-15.82 9.15l.03 63.96L64.38 128l23.77-13.72V50.29L72.3 41.14z"
        />
      </svg>
    ),
    prestashop_icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
      >
        <path
          fill="currentColor"
          d="M11.558 1.034C5.174 1.034 0 6.21 0 12.592c0 1.258.201 2.47.574 3.597l.002-.007a12.4 12.4 0 0 1 .53-1.787l.011-.03q.129-.333.277-.66l.084-.181q.12-.256.253-.507q.053-.102.108-.203c.02-.038.044-.073.064-.11q.14-.25.29-.493l.075-.114q.187-.292.393-.573l.035-.05q.217-.289.451-.563l.1-.118q.232-.266.481-.517l.099-.097a10 10 0 0 1 .546-.503c.74-2.48 3.005-4.285 5.686-4.285c1.079 0 2.152.31 3.071.873a6 6 0 0 1 2.211 2.407l.007.015l.04.074v.003l.004.002a10 10 0 0 1 1.567 1.198l.12.109c.002 0 .006.005.007.006l-.002-.006l-.001-.004v-.003l.042-.084c.377-2.384 1.43-4.102 2.67-4.102c.934 0 1.762.975 2.276 2.476l.005.016l.001.002q.218.236.424.521l.007.01l.021.067l-.02-.078c-1.542-4.569-5.863-7.857-10.952-7.857zM9.927 5.477C7.586 5.52 5.34 7.132 4.574 9.365l-.012.034a10 10 0 0 1 1.315-.895c2.806-1.656 6.479-1.646 9.278.016c-.895-1.653-2.631-2.819-4.5-3.004a5 5 0 0 0-.728-.039m9.834.5a1.4 1.4 0 0 0-.39.067c-1.265.562-1.719 2.073-2.031 3.303l-.016.072c.365-.62.808-1.215 1.396-1.642c.835-.687 2.105-.655 2.916.053c.308.326.141.008.031-.22c-.342-.75-1.025-1.653-1.906-1.634zM12.35 8.315l-1.07 3.27l-.002.005l-.006.002l-4.498 1.112h-.009l4.456 1.087q.159.166.36.28h.002q.063.035.129.065l.01.005q.062.026.126.047l.021.008q.06.019.12.032l.033.008a1.7 1.7 0 0 0 .318.033a1.55 1.55 0 0 0 1.43-.948c.08-.186.123-.39.123-.604v-.011l-.001-.012a2 2 0 0 0-.01-.16l-.001-.002a2 2 0 0 0-.026-.153l-.001-.004a1.5 1.5 0 0 0-.096-.288v-.003a1.5 1.5 0 0 0-.348-.49v-.003zm3.148.626c.048 1.008.036 2.046-.1 3.057c-.17 2.018-1.19 3.798-1.972 5.616l-.03.08l-.035.086c1.51-1.522 3.17-3.04 3.969-5.082c.383-.636.118-1.342-.115-1.976c-.17-.877-1.069-1.278-1.717-1.781m6.172.572l-.588 2.688a2 2 0 0 0-.047.2l-.01.06a2 2 0 0 0-.016.222l-.002.031h.003c0 .628.297 1.136.663 1.137a.4.4 0 0 0 .182-.045l.027-.015l.07-.047q.019-.016.036-.033a.8.8 0 0 0 .137-.168l.03-.054a1 1 0 0 0 .052-.108l.017-.04q.03-.08.053-.166l.002-.002l.001-.003l.404-.451l-.407-.456v.001l-.02-.063zm-4.381.856c.69 1.716.85 3.707.091 5.43c-.49 1.368-1.587 2.463-1.874 3.905q1.096.172 2.21.186c2.166.029 4.332-.42 6.284-1.365c-2.04-2.869-4.121-5.755-6.711-8.156m-4.948.977a.583.583 0 1 1 0 1.166a.583.583 0 0 1 0-1.166m9.352.37c.138 0 .249.19.249.426s-.111.426-.249.426c-.137 0-.248-.19-.248-.426c0-.235.11-.426.248-.426m-4.044.184a5 5 0 0 1-.05.29l-.006.023q-.016.076-.033.128c-.48 1.417-1.275 2.52-2.36 3.697q-.221.239-.459.484a59 59 0 0 1-1.196 1.205c-.112.11-.259.261-.425.436c-.103.287-.22.61-.318.95q-.065-.023-.131-.049c-2.108-.815-3.519-1.904-3.519-1.904s1.086 1.414 2.915 2.74q.265.192.522.339c-.075 1.194.452 2.34 2.83 2.682a4.8 4.8 0 0 0 1.228.008l-.01-.029l-.004-.01s-.167-.133-.379-.377a3.8 3.8 0 0 1-.584-.897a3.4 3.4 0 0 1-.266-.862a3.2 3.2 0 0 1-.006-.972q.025-.18.072-.366c.093-.374.255-.772.507-1.192l.002-.003l.241-.404c1.103-1.86 1.797-3.275 1.506-5.441a9 9 0 0 0-.078-.476zm4.681.779l.003.036v.01l-.003.038l.003-.043q0-.02-.003-.04zm-.012.275l-.002.01l-.002.014zm1.353 5.928c-2.553 1.138-5.44 1.44-8.192 1.007c-.14 1.108.384 2.218 1.214 2.93l.012.01c2.703-.433 4.975-2.168 6.966-3.946z"
        />
      </svg>
    ),
    check: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
      >
        <path
          fill="currentColor"
          d="m9.55 18l-5.7-5.7l1.425-1.425L9.55 15.15l9.175-9.175L20.15 7.4z"
        />
      </svg>
    )
  };

  const formatpercent = (value) => value + "%";
  const [aiPower, setAiPower] = useState(30);
  const [aiPowerLevel, setAiPowerLevel] = useState(30);
  const [show_calculator, showCalculator] = useState(false);

  const setAiPowerClosest = (val) => {
    let closest = 0;
    if (val === 0) {
      closest = 0;
    }
    // else if (val > 0 && val <= 10) {
    //   closest = 10;
    // }
    else if (val > 0 && val <= 30) {
      closest = 30;
    }
    // else if (val > 30 && val <= 50) {
    //   closest = 50;
    // }
    else if (val > 30 && val <= 60) {
      closest = 60;
    }
    // else if (val > 50 && val <= 70) {
    //   closest = 70;
    // }
    else if (val > 60) {
      closest = 90;
    }

    setAiPower(closest);
    setAiPowerLevel(closest);
    setSelectedTagNameList(
      aiPowerDetails[closest].selectedTagNameList.map((e) => e.label)
    );
  };

  const onShowCalculator = () => {
    showCalculator(!show_calculator);
  };

  const handleIconMouseEnter = (value, text) => {
    setHoverText([value, text]);
  };

  const handleIconMouseLeave = () => {
    setHoverText("");
  };

  const tagsList = StaticData.tagsList;

  const toggleItem = (index, tag) => {
    if (expandedItems.includes(index)) {
      console.log("toggleItem includes", index, tag);
      setSelectedTagNameList(
        selectedTagNameList.filter((item) => item !== tag.Name)
      );
      setExpandedItems(expandedItems.filter((item) => item !== tag.Name));
    } else {
      console.log("toggle no", index, tag);
      setSelectedTagNameList([...selectedTagNameList, tag.Name]);
      setExpandedItems([...expandedItems, tag.Name]);
    }
    console.log("selectedTagNameList", selectedTagNameList);
  };

  const removeItem = (index, tag) => {
    console.log("toggle remove", index, tag);
    console.log("selectedTagNameList is", selectedTagNameList);
    console.log("expandedItems is", expandedItems);
    setSelectedTagNameList(selectedTagNameList.filter((item) => item !== tag));
    setExpandedItems(expandedItems.filter((item) => item !== tag));
  };

  function fecthFullTime(agent_work_times) {
    setFullTime({
      week:
        agent_work_times["week"].open === 0 &&
        agent_work_times["week"].close === 24,
      week_end:
        agent_work_times["week_end"].open === 0 &&
        agent_work_times["week_end"].close === 24
    });
  }

  function fecthTimesByDays(agent_work_times) {
    setTimesByDay(
      agent_work_times ?? {
        week: { open: 0, close: 24 },
        week_end: { open: 0, close: 24 }
      }
    );
    if (agent_work_times) {
      initMarks(agent_work_times);
    }
  }

  const handleKeyDown = (event) => {
    if (!inputValue) return;
    switch (event.key) {
      case "Enter":
        setMaaiaNames((prev) => [...prev, createOption(inputValue)]);
        setInputValue("");
        event.preventDefault();
        break;
      case "Tab":
        setMaaiaNames((prev) => [...prev, createOption(inputValue)]);
        setInputValue("");
        event.preventDefault();
        break;
      default:
    }
  };

  const handleOnChange = (input) => {
    setInputValue(input);
    if (!input) return;
    if (input.endsWith(",")) {
      const val = input.substring(0, input.length - 1);
      setInputValue(val);
      setMaaiaNames((prev) => [...prev, createOption(val)]);
      setInputValue("");
    }
  };

  const handleOnBlur = () => {
    setPlaceholder(props.t("Donnez un nom à Synibox"));
    if (inputValue.trim() !== "") {
      setMaaiaNames((prev) => [...prev, createOption(inputValue)]);
      setInputValue("");
    }
  };

  // Fonction pour gérer le focus et placer le curseur au début
  const handleFocus = () => {
    setPlaceholder("");
  };

  const handleSwitchAiBehavior = async (state, ai_behavior_key) => {
    console.log("switch state is", state);
    console.log("switch ai_behavior_key is", ai_behavior_key);

    setAiBehavior((prev) => {
      const updatedStates = { ...prev };
      updatedStates[ai_behavior_key] = state;
      console.log("final updatedStates is", updatedStates);
      return updatedStates;
    });
    const response = await updateCompanyInfos({
      [ai_behavior_key]: state
    });
    // Créer le log
    if (response && localStorage.getItem("authUser")) {
      var user_id = JSON.parse(localStorage.getItem("authUser")).userId;
      let logData = {
        eventCreatedAt: response.$updatedAt,
        author_id: user_id,
        company_id: response.$id
      };
      let logdata = {
        event: `upated_${ai_behavior_key}`,
        author_id: user_id,
        company_id: response.$id,
        log_data: JSON.stringify(logData)
      };
      createLog(logdata, mixPanelTrack);
    }
  };

  const onUpdateAgentLoading = (value) => {
    setUpdateAgentLoading(value);
  };

  const toggleToast = () => {
    console.log("setToast before: " + toast);
    setToast(true);
    console.log("setToast after: " + toast);

    setTimeout(() => {
      setToast(false);
    }, 3000);
  };

  function arrayObjectToList(array) {
    const stringList = array.map((item) => item.value);
    return stringList;
  }

  const handleModalAgentUpdate = async () => {
    const updatedAgentsList = [];
    updatedAgentsList[0] =
      agentData.length === 0
        ? {
            id: Date.now().toString(),
            agent_work_times: timesByDay,
            agent_name: arrayObjectToList(maaiaNames),
            agent_language: selectedAgentLanguages,
            agent_timezone: agentSelectedTimezone,
            agent_tone_communication: toneSelected,
            agent_greeting: selectedGreeting,
            agent_polite_formula: selectedFormula
          }
        : {
            ...agent,
            agent_work_times: timesByDay,
            agent_name: arrayObjectToList(maaiaNames),
            agent_language: selectedAgentLanguages,
            agent_timezone: agentSelectedTimezone,
            agent_tone_communication: toneSelected,
            agent_greeting: selectedGreeting,
            agent_polite_formula: selectedFormula
          };

    console.log("updatedAgentsList is", updatedAgentsList);

    onUpdateAgentLoading(true);

    updateCompanyInfos({
      agents: updatedAgentsList.map((element) => JSON.stringify(element))
    })
      .then((response) => {
        onUpdateAgentLoading(false);

        // Créer le log
        var user_id = JSON.parse(localStorage.getItem("authUser")).userId;
        let logData = {
          eventCreatedAt: response?.$createdAt,
          author_id: user_id,
          company_id: client_data.$id,
          agent_id: agent.$id
        };
        let logdata = {
          event: "agent_updated",
          author_id: user_id,
          company_id: client_data.$id,
          log_data: JSON.stringify(logData)
        };
        createLog(logdata, mixPanelTrack);

        // togUpdateAgentModal();
        onUpdateAgentLoading(false);

        setUpdateUserPrefsLoading({
          title: props.t("Succès"),
          message: props.t(
            "Vos modifications ont été enregistrées avec succès"
          ),
          loading: false,
          key: "success"
        });
        toggleToast();
      })
      .catch((error) => {
        // Gérer les erreurs ici si nécessaire
        console.error(
          "Erreur lors de la mise à jour des informations de l'entreprise :",
          error
        );
        onUpdateAgentLoading(false);
        // togUpdateAgentModal();
        setUpdateUserPrefsLoading({
          title: props.t("Echec"),
          message: props.t("Erreur inattendu, veuillez réessayer."),
          loading: false,
          key: "danger"
        });
        toggleToast();
      });
  };

  async function saveDelai(interval, intervalText) {
    setDelaiSelected(intervalText);
    await updateCompanyInfos({ email_treatment_interval: interval });
    setDelaiSelected(intervalText);
    updateAgentFunctionExecution(
      localStorage.getItem("companyId"),
      agent.id,
      interval
    );
  }

  // const customStyles = {
  //   control: (provided, state) => ({
  //     ...provided
  //   }),
  //   option: (provided, state) => ({
  //     ...provided,
  //     backgroundColor: state.isSelected ? "#2684FF" : "#fff",
  //     color: state.isSelected ? "#fff" : "#333",
  //     padding: 10
  //   })
  // };

  function onTimesByDay(day, e) {
    setTimesByDay((prevState) => {
      return {
        ...prevState,
        [day]: {
          ...prevState[day],
          open: e[0],
          close: e[1]
        }
      };
    });
    generateMarks(day, e[0], e[1]);
  }

  const generateMarks = (day, min, max) => {
    const makes = {
      week: day === "week_end" ? marks["week"] : {},
      week_end: day === "week" ? marks["week_end"] : {}
    };

    makes[day][min] = min === 24 ? "23h59" : `${min}h`;
    makes[day][max] = max === 24 ? "23h59" : `${max}h`;

    setMarks(makes);
  };

  const initMarks = (agent_work_timeseries) => {
    const weekOpen = agent_work_timeseries["week"].open;
    const weekClose = agent_work_timeseries["week"].close;
    const weekEndOpen = agent_work_timeseries["week_end"].open;
    const weekEndClose = agent_work_timeseries["week_end"].close;
    const makes = { week: {}, week_end: {} };

    makes["week"][weekOpen] = weekOpen === 24 ? "23h59" : `${weekOpen}h`;
    makes["week"][weekClose] = weekClose === 24 ? "23h59" : `${weekClose}h`;

    makes["week_end"][weekEndOpen] =
      weekEndOpen === 24 ? "23h59" : `${weekEndOpen}h`;
    makes["week_end"][weekEndClose] =
      weekEndClose === 24 ? "23h59" : `${weekEndClose}h`;

    setMarks(makes);
  };

  const [ressources_data_loading, setRessourcesDataLoading] = useState(false);

  const onRessourcesDataLoading = (val) => {
    setRessourcesDataLoading(val);
  };

  async function updateRessources() {
    const companyId = localStorage.getItem("companyId");

    if (companyId) {
      if ((client_data.contact_reasons ?? []) !== selectedTagNameList) {
        onRessourcesDataLoading(true);
        await updateCompanyInfos(
          {
            contact_reasons: selectedTagNameList
          },
          ["tag_updated"]
        );

        var category_percentage =
          (selectedTagNameList.length * 100) / (tagsList.length + 1);
        var percentage_maaia;
        if (category_percentage < 30) {
          percentage_maaia = "-30%";
        } else if (category_percentage >= 30 && category_percentage < 50) {
          percentage_maaia = "30% - 50%";
        } else if (category_percentage >= 50 && category_percentage < 80) {
          percentage_maaia = "50% - 80%";
        } else if (category_percentage >= 80) {
          percentage_maaia = "+80%";
        }

        const updates = {
          properties: {
            category_percentage: percentage_maaia
          }
        };

        klaviyoUpdateProfile(client_data.$id, updates);
      }
      onRessourcesDataLoading(false);
    } else {
      onRessourcesDataLoading(false);
      console.log("no company id");
    }
  }

  return (
    <div>
      <div
        className="position-fixed bottom-0 end-0 p-3 font-primary"
        style={{ zIndex: "1005" }}
      >
        <CustomToast
          isOpen={toast}
          toggle={toggleToast}
          message={{
            title: updateUserPrefsLoading.title,
            body: updateUserPrefsLoading.message,
            key: updateUserPrefsLoading.key
          }}
        />
      </div>
      {client_data ? (
        <div className="users-tabpane col-xxl-8 col-xl-9 mx-auto">
          <div
            className="ressources"
            style={{
              marginBottom: "20px",
              borderRadius: "10px",
              background: "#FFF",
              border: "1px solid rgb(233, 236, 239)",
              padding: "20px"
            }}
          >
            <Row className="align-items-center justify-content-between flex-row ">
              <div
                className="col-auto"
                style={{
                  height: "30px",
                  width: "30px",
                  backgroundImage: "url(" + synibix_icon_buble_chat + ")",
                  backgroundSize: "contain",
                  marginLeft: "10px"
                }}
              ></div>
              <Col>
                <div style={{ width: "fit-content" }}>
                  <h4
                    className="section-title font-primary mb-0"
                    style={{ fontSize: "18px" }}
                  >
                    {props.t("Configuration de Synibox")}
                  </h4>
                </div>
              </Col>
            </Row>
            <Row className="mb-4 align-items-center">
              <Col>
                <div className="font-primary simple-text">
                  {props.t(
                    "Configurez Synibox pour qu'elle corresponde parfaitement à vos besoins et à ceux de vos clients."
                  )}
                </div>
              </Col>
            </Row>
            <Row className="mb-2">
              <Row className=" align-items-center">
                <Col lg={6}>
                  <Row>
                    <Col lg={5}>
                      <Label htmlFor="basicpill-name-input42" className="mb-2">
                        {props.t("Etat de votre assistant Synibox")}{" "}
                        <span
                          style={{ cursor: "pointer", color: "#563BFF" }}
                          onMouseEnter={() =>
                            handleIconMouseEnter(
                              9,
                              props.t(
                                "Vous pouvez sélectionner un nom unique qui reflète votre marque ou utiliser les prénoms de votre équipe pour varier les interactions."
                              )
                            )
                          }
                          onMouseLeave={handleIconMouseLeave}
                        >
                          {svgs.info_icon}
                          {hoverText[0] === 9 && (
                            <div
                              className="hover-text-onboarding font-primary"
                              style={{
                                top: "0",
                                right: "0",
                                padding: "5px 10px",
                                fontWeight: "400",
                                transform: "translate(-10%, -90%)"
                              }}
                            >
                              {hoverText[1]}
                            </div>
                          )}
                        </span>{" "}
                      </Label>
                    </Col>
                    <Col className="col-auto">
                      <MaaiaChangeStatus />
                    </Col>
                  </Row>
                </Col>

                <Col lg={6}>
                  <FormGroup className="mb-4 mt-2">
                    <Row className="justify-content-between">
                      <Col lg={8}>
                        <Label htmlFor="">
                          {props.t("Délai de traitement des e-mails")}{" "}
                          <span
                            style={{ cursor: "pointer", color: "#563BFF" }}
                            onMouseEnter={() =>
                              handleIconMouseEnter(
                                11,
                                props.t("Délai de traitement des e-mails")
                              )
                            }
                            onMouseLeave={handleIconMouseLeave}
                          >
                            {svgs.info_icon}
                            {hoverText[0] === 11 && (
                              <div
                                className="hover-text-onboarding font-primary"
                                style={{
                                  top: "0",
                                  right: "0",
                                  width: "400px",
                                  padding: "5px 10px",
                                  fontWeight: "400",
                                  transform: "translate(-25%, -90%)"
                                }}
                              >
                                <span style={{ opacity: 0.7 }}>
                                  {hoverText[1]}
                                </span>
                              </div>
                            )}
                          </span>{" "}
                        </Label>
                      </Col>
                      <Col className="col-auto">
                        <div className="mb-3 on-boarding-select-container select2-container font-primary">
                          {/* <Select
                        isOptionDisabled={(option, selectValue) => {
                          return false;
                        }}
                        value={delaiSelected}
                        onChange={(e) => saveDelai(e.value === "15min" ? 15 : e.value === "30min" ? 30 : 60, e.value)}
                        options={delais.map((del) => {
                          return {
                            label: del,
                            value: props.t(del)
                          };
                        })}
                        styles={customStyles} // Appliquer le style personnalisé
                        style={{ zIndex: "9999" }}
                        classNamePrefix="select2-selection"
                        closeMenuOnSelect={true}
                      /> */}
                          <select
                            className="form-select"
                            aria-label="Label select example"
                            value={delaiSelected}
                            onChange={(e) =>
                              saveDelai(
                                e.target.value === "< 5min"
                                  ? 5
                                  : e.target.value === "15min"
                                  ? 15
                                  : e.target.value === "30min"
                                  ? 30
                                  : 60,
                                e.target.value
                              )
                            }
                            style={{
                              backgroundColor: "#f7f8fb",
                              border: "none",
                              borderRadius: "10px"
                            }}
                          >
                            {delais.map((del) => {
                              return (
                                <option key={del} value={props.t(del)}>
                                  {del}
                                </option>
                              );
                            })}
                          </select>
                        </div>
                      </Col>
                    </Row>
                  </FormGroup>
                </Col>
              </Row>

              {/* {client_data &&
              (!client_data.shopify_token ||
                !client_data.shopify_store_url) && (
                <div className="mt-1 font-size-12" style={{ color: "red" }}>
                  {props.t(
                    "Votre CMS n'est pas connecté. Veuillez le connecter pour activer les fonctionnalités de Synibox."
                  )}
                </div>
              )} */}
            </Row>
            <Row className="mt-2">
              <Col lg={6}>
                <FormGroup className="mb-4 mt-2">
                  <Label htmlFor="basicpill-name-input42">
                    {props.t("Noms / Alias de votre assistant (signature)")}{" "}
                    <span
                      style={{ cursor: "pointer", color: "#563BFF" }}
                      onMouseEnter={() =>
                        handleIconMouseEnter(
                          1,
                          props.t(
                            "Vous pouvez sélectionner un nom unique qui reflète votre marque ou utiliser les prénoms de votre équipe pour varier les interactions."
                          )
                        )
                      }
                      onMouseLeave={handleIconMouseLeave}
                    >
                      {svgs.info_icon}
                      {hoverText[0] === 1 && (
                        <div
                          className="hover-text-onboarding font-primary"
                          style={{
                            top: "0",
                            right: "0",
                            padding: "5px 10px",
                            fontWeight: "400",
                            transform: "translate(-40%, -90%)"
                          }}
                        >
                          <span style={{ opacity: 0.7 }}>{hoverText[1]}</span>
                        </div>
                      )}
                    </span>{" "}
                    <div style={{ fontSize: "12px", fontWeight: "normal" }}>
                      {props.t(
                        "Configurez le ou les prénoms sous lesquels Synibox signera ses emails et messages ( séparé(s) par une virgule )."
                      )}
                    </div>
                  </Label>
                  <div className="on-boarding-select-container select2-container font-primary">
                    <CreatableSelect
                      components={components}
                      inputValue={inputValue}
                      isClearable
                      isMulti
                      menuIsOpen={false}
                      onChange={(newValue) => setMaaiaNames(newValue)}
                      onInputChange={(newValue) => handleOnChange(newValue)}
                      onBlur={() => handleOnBlur()}
                      onFocus={handleFocus}
                      // onKeyDown={handleKeyDown}
                      placeholder={placeholder}
                      classNamePrefix="select2-selection"
                      value={maaiaNames}
                    />
                  </div>
                  {maaiaNames.length === 0 && nameInputTouched ? (
                    <div
                      className="font-primary"
                      style={{
                        width: "100%",
                        marginTop: "0.25rem",
                        fontSize: "80%",
                        color: "#ff3d60"
                      }}
                    >
                      <div>{props.t("Please enter a name for your agent")}</div>
                    </div>
                  ) : null}
                </FormGroup>
              </Col>

              <Col lg={6}>
                <FormGroup className="mb-4 mt-2">
                  <div>
                    <Label htmlFor="basicpill-language-input42">
                      {/* (${selectedAgentLanguages.length}/${number_of_languages}) */}
                      {`${props.t("Choix des langues")}`}{" "}
                      <span
                        style={{ cursor: "pointer", color: "#563BFF" }}
                        onMouseEnter={() =>
                          handleIconMouseEnter(
                            2,
                            props.t(
                              "Vous pourrez modifier les langues de Synibox à tout moment dans la partie paramètre de votre compte."
                            )
                          )
                        }
                        onMouseLeave={handleIconMouseLeave}
                      >
                        {svgs.info_icon}
                        {hoverText[0] === 2 && (
                          <div
                            className="hover-text-onboarding font-primary"
                            style={{
                              top: "0",
                              right: "0",
                              width: "400px",
                              padding: "5px 10px",
                              fontWeight: "400",
                              transform: "translate(-70%, -90%)"
                            }}
                          >
                            <span style={{ opacity: 0.7 }}>{hoverText[1]}</span>
                          </div>
                        )}
                      </span>{" "}
                      <div style={{ fontSize: "12px", fontWeight: "normal" }}>
                        {props.t(
                          "Sélectionnez la/les langue(s) principale(s) pour les interactions de Synibox avec vos clients."
                        )}
                      </div>
                      {selectedAgentLanguages &&
                        number_of_languages ===
                          selectedAgentLanguages.length && (
                          <div
                            onClick={() => onShowCalculator()}
                            className="font-size-12"
                            style={{
                              float: "right",
                              fontWeight: "normal",
                              color: "rgb(86, 59, 255)",
                              cursor: "pointer"
                            }}
                          >
                            {props.t("Upgrade to get more")}
                          </div>
                        )}
                    </Label>
                  </div>
                  {/* <Dropdown
                              isOpen={languageDropdownOpen}
                              toggle={() => setLanguageDropdownOpen(!languageDropdownOpen)}
                              style={{
                                backgroundColor: "#f7f8fb",
                                border: "none",
                                height: "40px",
                                borderRadius: "10px",
                              }}>
                              <DropdownToggle
                                className="header-item waves-effect d-flex align-items-center gap-2 w-100"
                                tag="button"
                                style={{ backgroundColor: "transparent" }}>
                                <img src={languages[selectLangCode].flag} alt="iAssistant" height="16" className="" />
                                <span className="align-middle">{props.t(languages[selectLangCode].label)}</span>
                              </DropdownToggle>
                              <DropdownMenu className="language-switch dropdown-menu-lg dropdown-menu-start">
                                {map(Object.keys(languages), (key) => (
                                  <DropdownItem
                                    key={key}
                                    onClick={() => changeLanguageAction(key, languages[key].label)}
                                    className={`notify-item d-flex align-items-center gap-2 ${selectLangCode === key ? "active" : "none"}`}>
                                    <img src={languages[key].flag} alt="iAssistant" className="" height="12" />

                                    <span className="align-middle">{props.t(languages[key].label)}</span>
                                  </DropdownItem>
                                ))}
                              </DropdownMenu>
                            </Dropdown> */}
                  <div className="mb-3 on-boarding-select-container select2-container font-primary">
                    <Select
                      isOptionDisabled={(option, selectValue) => {
                        return false;
                      }}
                      styles={{
                        option: (provided, state) => ({
                          ...provided,
                          cursor:
                            selectedAgentLanguages &&
                            number_of_languages ===
                              selectedAgentLanguages.length
                              ? "not-allowed"
                              : "pointer",
                          backgroundColor: "transparent"
                        })
                      }}
                      style={{ zIndex: "9999" }}
                      value={selectedAgentLanguages.map((lang) => {
                        return {
                          label: props.t(lang.name),
                          value: lang.code
                        };
                      })}
                      isMulti={true}
                      onChange={(e) => {
                        if (
                          number_of_languages > selectedAgentLanguages.length ||
                          e.length <= number_of_languages
                        ) {
                          setSelectedAgentLanguages(
                            e.map((lang) => {
                              return { name: lang.label, code: lang.value };
                            })
                          );
                        }
                      }}
                      placeholder={props.t("Select") + "..."}
                      options={languages.map((lang) => {
                        return {
                          label: props.t(lang.label),
                          value: lang.code
                        };
                      })}
                      classNamePrefix="select2-selection"
                      closeMenuOnSelect={false}
                      components={animatedComponents}
                    />
                    {selectedAgentLanguages.length === 0 && (
                      <span className="font-size-12" style={{ color: "red" }}>
                        {props.t(
                          "Vous devez sélectionner au moins une langue pour Synibox."
                        )}
                      </span>
                    )}
                  </div>
                </FormGroup>
              </Col>
            </Row>
          </div>

          <div
            className="ressources"
            style={{
              marginBottom: "20px",
              borderRadius: "10px",
              background: "#FFF",
              border: "1px solid rgb(233, 236, 239)",
              padding: "20px"
            }}
          >
            <Row>
              <Col lg={6}>
                <FormGroup className="mb-4 mt-2">
                  <Label htmlFor="">
                    {props.t("Ton de Communication")}{" "}
                    <span
                      style={{ cursor: "pointer", color: "#563BFF" }}
                      onMouseEnter={() =>
                        handleIconMouseEnter(
                          4,
                          props.t(
                            "Choisissez entre un style formel, informel, amical ou professionnel pour garantir que chaque interaction reflète l'approche souhaitée de votre marque."
                          )
                        )
                      }
                      onMouseLeave={handleIconMouseLeave}
                    >
                      {svgs.info_icon}
                      {hoverText[0] === 4 && (
                        <div
                          className="hover-text-onboarding font-primary"
                          style={{
                            top: "0",
                            right: "0",
                            width: "400px",
                            padding: "5px 10px",
                            fontWeight: "400",
                            transform: "translate(-45%, -90%)"
                          }}
                        >
                          <span style={{ opacity: 0.7 }}>{hoverText[1]}</span>
                        </div>
                      )}
                    </span>{" "}
                    <div style={{ fontSize: "12px", fontWeight: "normal" }}>
                      {props.t(
                        "Adaptez le ton de Synibox pour qu'il corresponde parfaitement à l'image de votre marque."
                      )}
                    </div>
                  </Label>
                  <div className="mb-3">
                    <select
                      className="form-select"
                      aria-label="Label select example"
                      value={toneSelected}
                      onChange={(e) => setToneSelected(e.target.value)}
                      style={{
                        backgroundColor: "#f7f8fb",
                        border: "none",
                        borderRadius: "10px"
                      }}
                    >
                      {tones.map((tone) => {
                        return (
                          <option key={tone} value={props.t(tone)}>
                            {props.t(tone)}
                          </option>
                        );
                      })}
                    </select>
                  </div>
                </FormGroup>
              </Col>

              <Col lg={6}>
                <FormGroup className="mb-4 mt-2">
                  <div>
                    <Label htmlFor="basicpill-language-input42">
                      {props.t("Formules de politesse")}{" "}
                      <span
                        style={{ cursor: "pointer", color: "#563BFF" }}
                        onMouseEnter={() =>
                          handleIconMouseEnter(
                            5,
                            props.t(
                              "Ajoutez jusqu’à 5 expressions pour ouvrir et clore les communications pour assurer que chaque interaction avec vos clients sera alignée avec le ton et le style de votre marque."
                            )
                          )
                        }
                        onMouseLeave={handleIconMouseLeave}
                      >
                        {svgs.info_icon}
                        {hoverText[0] === 5 && (
                          <div
                            className="hover-text-onboarding font-primary"
                            style={{
                              top: "0",
                              right: "0",
                              width: "400px",
                              padding: "5px 10px",
                              fontWeight: "400",
                              transform: "translate(-50%, -90%)"
                            }}
                          >
                            <span style={{ opacity: 0.7 }}>{hoverText[1]}</span>
                          </div>
                        )}
                      </span>{" "}
                      <div
                        style={{
                          fontSize: "12px",
                          fontWeight: "normal",
                          marginTop: marginPolite
                        }}
                      >
                        {props.t(
                          "Personnalisez les salutations et les formules de clôture dans les communications de Synibox."
                        )}
                      </div>
                    </Label>
                  </div>
                  <div className="mt-2 mb-4 on-boarding-select-container select2-container font-primary">
                    <CreatableSelect
                      isOptionDisabled={(option, selectValue) => {
                        return false;
                      }}
                      styles={{
                        option: (provided, state) => ({
                          ...provided,
                          cursor: "pointer",
                          backgroundColor: "transparent"
                        })
                      }}
                      style={{ zIndex: "9999" }}
                      value={selectedGreeting.map((greet) => {
                        return {
                          label: greet,
                          value: greet
                        };
                      })}
                      isMulti={true}
                      onChange={(e) => {
                        setSelectedGreeting(
                          e.map((greet) => {
                            return greet.value;
                          })
                        );
                      }}
                      placeholder={props.t("Select") + "..."}
                      options={greetings.map((greet) => {
                        return {
                          label:
                            localStorage.getItem("I18N_LANGUAGE") === "en"
                              ? greet.label_en
                              : greet.label_fr,
                          value:
                            localStorage.getItem("I18N_LANGUAGE") === "en"
                              ? greet.label_en
                              : greet.label_fr
                        };
                      })}
                      formatCreateLabel={(inputValue) =>
                        `${props.t("Ajouter")} "${inputValue}"`
                      }
                      classNamePrefix="select2-selection"
                      closeMenuOnSelect={false}
                      components={animated2Components}
                    />
                    {/* {selectedAgentLanguages.length === 0 && (
                                <span className="font-size-12" style={{ color: "red" }}>
                                  {props.t("Vous devez sélectionner au moins une langue pour Synibox.")}
                                </span>
                              )} */}
                  </div>

                  <div className="mb-3 on-boarding-select-container select2-container font-primary">
                    <CreatableSelect
                      isOptionDisabled={(option, selectValue) => {
                        return false;
                      }}
                      styles={{
                        option: (provided, state) => ({
                          ...provided,
                          cursor: "pointer",
                          backgroundColor: "transparent"
                        })
                      }}
                      style={{ zIndex: "9999" }}
                      value={selectedFormula.map((formula) => {
                        return {
                          label: formula,
                          value: formula
                        };
                      })}
                      isMulti={true}
                      onChange={(e) => {
                        setSelectedFormula(
                          e.map((formula) => {
                            return formula.value;
                          })
                        );
                      }}
                      placeholder={props.t("Select") + "..."}
                      options={formulas.map((formula) => {
                        return {
                          label:
                            localStorage.getItem("I18N_LANGUAGE") === "en"
                              ? formula.label_en
                              : formula.label_fr,
                          value:
                            localStorage.getItem("I18N_LANGUAGE") === "en"
                              ? formula.label_en
                              : formula.label_fr
                        };
                      })}
                      formatCreateLabel={(inputValue) =>
                        `${props.t("Ajouter")} "${inputValue}"`
                      }
                      classNamePrefix="select2-selection"
                      closeMenuOnSelect={false}
                      components={animated3Components}
                    />
                    {/* {selectedAgentLanguages.length === 0 && (
                                <span className="font-size-12" style={{ color: "red" }}>
                                  {props.t("Vous devez sélectionner au moins une langue pour Synibox.")}
                                </span>
                              )} */}
                  </div>
                </FormGroup>
              </Col>
            </Row>
          </div>

          <div
            className="ressources"
            style={{
              marginBottom: "20px",
              borderRadius: "10px",
              background: "#FFF",
              border: "1px solid rgb(233, 236, 239)",
              padding: "20px"
            }}
          >
            <Row>
              <Col lg={6}>
                <FormGroup className="mb-4 mt-2">
                  <Label htmlFor="">
                    {props.t("Fuseau horaire de Synibox")}
                    <span
                      style={{ cursor: "pointer", color: "#563BFF" }}
                      onMouseEnter={() =>
                        handleIconMouseEnter(
                          3,
                          props.t(
                            "Réglez le fuseau horaire selon votre localisation géographique ou celle de votre principal marché cible pour que Synibox gère les interactions en temps opportun."
                          )
                        )
                      }
                      onMouseLeave={handleIconMouseLeave}
                    >
                      {svgs.info_icon}
                      {hoverText[0] === 3 && (
                        <div
                          className="hover-text-onboarding font-primary"
                          style={{
                            top: "0",
                            right: "0",
                            width: "400px",
                            padding: "5px 10px",
                            fontWeight: "400",
                            transform: "translate(-45%, -90%)"
                          }}
                        >
                          <span style={{ opacity: 0.7 }}>{hoverText[1]}</span>
                        </div>
                      )}
                    </span>{" "}
                    <div
                      className="mt-3"
                      style={{ fontSize: "12px", fontWeight: "normal" }}
                    >
                      {props.t("Réglez le fuseau horaire de Synibox.")}
                    </div>
                  </Label>
                  <div className="mb-2 on-boarding-select-container select2-container font-primary">
                    <Select
                      isOptionDisabled={(option, selectValue) => {
                        return false;
                      }}
                      styles={{
                        option: (provided, state) => ({
                          ...provided,
                          cursor: "pointer",
                          backgroundColor: "transparent"
                        })
                      }}
                      style={{ zIndex: "9999" }}
                      value={{
                        label: agentSelectedTimezone,
                        value: agentSelectedTimezone
                      }}
                      onChange={(e) => setAgentTimezone(setUtc(e.value))}
                      placeholder={props.t("Select") + "..."}
                      options={timezones.map((timezone) => {
                        return {
                          label: setUtc(timezone),
                          value: timezone
                        };
                      })}
                      classNamePrefix="select2-selection"
                      closeMenuOnSelect={true}
                      // components={animated2Components}
                    />
                    {/* <label htmlFor="floatingSelectGrid">
                                <p style={{ backgroundColor: "#f7f8fb" }}>
                                  {props.t("Fuseau sélectionné")}:{agentSelectedTimezone}
                                </p>
                              </label> */}
                  </div>
                </FormGroup>
              </Col>
              <Col lg={6}>
                {/* style={{ marginTop: "3.5rem" }} */}
                <FormGroup className="mb-4 mt-2">
                  <div className="d-flex align-items-center flex-wrap gap-2">
                    <input
                      type="checkbox"
                      style={{
                        backgroundColor:
                          fullTime["week"] === true &&
                          fullTime["week_end"] === true
                            ? "#05B714"
                            : "#FFFFFF",
                        borderColor:
                          fullTime["week"] === true &&
                          fullTime["week_end"] === true
                            ? "#05B714"
                            : "#563BFF",
                        fontSize: "14px"
                      }}
                      className="form-check-input"
                      id={"fulltime"}
                      name={"fulltime"}
                      value={
                        fullTime["week"] === true &&
                        fullTime["week_end"] === true
                      }
                      defaultChecked={
                        fullTime["week"] === true &&
                        fullTime["week_end"] === true
                      }
                      onChange={(e) => {
                        setFullTime({
                          week: e.target.checked,
                          week_end: e.target.checked
                        });
                        setTimesByDay({
                          week: {
                            open: e.target.checked === false ? 8 : 0,
                            close: e.target.checked === false ? 16 : 24
                          },
                          week_end: {
                            open: e.target.checked === false ? 8 : 0,
                            close: e.target.checked === false ? 16 : 24
                          }
                        });
                        setMarks({
                          week:
                            e.target.checked === false
                              ? {
                                  8: "8h",
                                  16: "16h"
                                }
                              : {
                                  0: "0h",
                                  24: "23h59"
                                },
                          week_end:
                            e.target.checked === false
                              ? {
                                  8: "8h",
                                  16: "16h"
                                }
                              : {
                                  0: "0h",
                                  24: "23h59"
                                }
                        });
                      }}
                    />
                    <div>
                      <span
                        style={{
                          color: "#171C1B",
                          fontFamily: "Poppins,sans-serif",
                          fontSize: "14px",
                          fontStyle: "normal",
                          fontWeight: 600,
                          lineHeight: "normal"
                        }}
                      >
                        {props.t("full_time_ia_checkbox")}{" "}
                        <span
                          style={{ cursor: "pointer", color: "#563BFF" }}
                          onMouseEnter={() =>
                            handleIconMouseEnter(
                              6,
                              props.t(
                                "Ajustez les horaires de réponse de Synibox selon vos besoins pour maintenir la cohérence avec l'identité de votre marque."
                              )
                            )
                          }
                          onMouseLeave={handleIconMouseLeave}
                        >
                          {svgs.info_icon}
                          {hoverText[0] === 6 && (
                            <div
                              className="hover-text-onboarding font-primary"
                              style={{
                                top: "0",
                                right: "0",
                                width: "400px",
                                padding: "5px 10px",
                                fontWeight: "400",
                                transform: "translate(-65%, -90%)"
                              }}
                            >
                              <span style={{ opacity: 0.7 }}>
                                {hoverText[1]}
                              </span>
                            </div>
                          )}
                        </span>
                      </span>
                    </div>
                  </div>
                </FormGroup>
                <div
                  style={{
                    fontSize: "12px",
                    fontWeight: "normal",
                    marginTop: "5px"
                  }}
                >
                  {props.t(
                    "Choisissez les horaires auxquels Synibox peut répondre."
                  )}
                </div>
                <div style={{ marginTop: "5px", marginLeft: "10px" }}>
                  <Row>
                    <FormGroup className="">
                      <Row>
                        {daysOfWeek.map(
                          (day, index) => (
                            <Col lg={12}>
                              <Row className="mb-2 align-items-center">
                                <Col className="col-5">
                                  <div>
                                    <label
                                      className="form-check-label ms-2"
                                      htmlFor={"customSwitchsizemd_" + day}
                                    >
                                      {day === "week" ? (
                                        <div style={{ fontSize: "12px" }}>
                                          <span>
                                            {props.t("Jours de la semaine")}
                                          </span>{" "}
                                          :
                                          <div
                                            style={{
                                              fontSize: "10px",
                                              fontWeight: "normal"
                                            }}
                                          >
                                            {props.t("(Lundi au Vendredi)")}
                                          </div>
                                        </div>
                                      ) : (
                                        <div style={{ fontSize: "12px" }}>
                                          {props.t("Jours du weekend")} :
                                          <div
                                            style={{
                                              fontSize: "10px",
                                              fontWeight: "normal"
                                            }}
                                          >
                                            {props.t("(Samedi au Dimanche)")}
                                          </div>
                                        </div>
                                      )}
                                    </label>
                                  </div>
                                </Col>
                                <Col className="col-7" key={day}>
                                  <div
                                    style={{
                                      height: "50px",
                                      backgroundColor: "#f7f8fb",
                                      paddingTop: "10px",
                                      paddingLeft: "20px",
                                      paddingRight: "25px"
                                    }}
                                  >
                                    <Slider
                                      key={day}
                                      min={0}
                                      max={24}
                                      step={1}
                                      value={[
                                        timesByDay[day].open,
                                        timesByDay[day].close
                                      ]}
                                      range
                                      marks={marks[day]}
                                      onChange={(e) => {
                                        setFullTime({
                                          week:
                                            day === "week"
                                              ? e[0] > 0 || e[1] < 24
                                                ? false
                                                : true
                                              : fullTime["week"],
                                          week_end:
                                            day === "week_end"
                                              ? e[0] > 0 || e[1] < 24
                                                ? false
                                                : true
                                              : fullTime["week_end"]
                                        });
                                        onTimesByDay(day, e);
                                      }}
                                    />
                                  </div>
                                  {/* <MultiRangeSlider
                                  key={index}
                                  id={"cussss" + index}
                                  disabled={false}
                                  min={0}
                                  max={24}
                                  step={1}
                                  minValue={timesByDay[day].open}
                                  maxValue={timesByDay[day].close}
                                  minCaption={
                                    timesByDay[day].open === 0
                                      ? "00h01"
                                      : (timesByDay[day].open < 10 ? "0" + timesByDay[day].open : timesByDay[day].open) + "h"
                                  }
                                  maxCaption={
                                    timesByDay[day].close < 10
                                      ? "0" + timesByDay[day].close + "h"
                                      : timesByDay[day].close === 24
                                      ? props.t("23h59")
                                      : timesByDay[day].close + "h"
                                  }
                                  onChange={(e) => {
                                    setFullTime({
                                      week: e.minValue > 0 || e.maxValue < 24 ? false : true,
                                      week_end: e.minValue > 0 || e.maxValue < 24 ? false : true
                                    });
                                    setTimesByDay((prevState) => {
                                      return {
                                        ...prevState,
                                        [day]: {
                                          ...prevState[day],
                                          open: e.minValue,
                                          close: e.maxValue
                                        }
                                      };
                                    });
                                  }}
                                  onInput={(e) => {
                                    setFullTime({
                                      week: e.minValue > 0 || e.maxValue < 24 ? false : true,
                                      week_end: e.minValue > 0 || e.maxValue < 24 ? false : true
                                    });
                                    setTimesByDay((prevState) => {
                                      return {
                                        ...prevState,
                                        [day]: {
                                          ...prevState[day],
                                          open: e.minValue,
                                          close: e.maxValue
                                        }
                                      };
                                    });
                                  }}
                                  style={{
                                    border: "none",
                                    boxShadow: "none",
                                    background: "#F7F8FB",
                                    padding: "20px 20px"
                                  }}
                                  labels={["", ""]}
                                  ruler={false}
                                  barLeftColor="#F7F8FB"
                                  barInnerColor="#563BFF"
                                  barRightColor="#F7F8FB"
                                  thumbLeftColor="white"
                                  thumbRightColor="white"
                                /> */}
                                </Col>
                              </Row>
                            </Col>
                          )
                          // ) : (
                          //   <Col lg={6} key={day}>
                          //     <Row className="mb-3">
                          //       <Col className="col-4">
                          //         <div
                          //           className="form-check form-switch form-switch-md ms-xxl-3"
                          //           style={{
                          //             height: "100%",
                          //             display: "flex",
                          //             alignItems: "center",
                          //           }}>
                          //           <label className="form-check-label ms-2" htmlFor={"customSwitchsizemd_" + day}>
                          //             {day === "weeek" ? (
                          //               <div>
                          //                 {props.t("Jours de la semaine")} :<span>{props.t("(Lundi au Vendredi)")}</span>
                          //               </div>
                          //             ) : (
                          //               <div>
                          //                 {props.t("Jours du Weekend")} :<span>{props.t("(Samedi au Dimanche)")}</span>
                          //               </div>
                          //             )}
                          //           </label>
                          //         </div>
                          //       </Col>
                          //       <Col className="col-8">
                          //         <MultiRangeSlider
                          //           disabled={true}
                          //           min={0}
                          //           max={24}
                          //           minValue={0}
                          //           step={1}
                          //           maxValue={24}
                          //           minCaption={
                          //             timesByDay[day].open === 0
                          //               ? "00h01"
                          //               : (timesByDay[day].open < 10 ? "0" + timesByDay[day].open : timesByDay[day].open) + "h"
                          //           }
                          //           maxCaption={
                          //             timesByDay[day].close < 10
                          //               ? "0" + timesByDay[day].close + "h"
                          //               : timesByDay[day].close === 24
                          //               ? props.t("23h59")
                          //               : timesByDay[day].close + "h"
                          //           }
                          //           onChange={(e) => {
                          //             setTimesByDay((prevState) => {
                          //               return {
                          //                 ...prevState,
                          //                 [day]: {
                          //                   ...prevState[day],
                          //                   open: e.minValue,
                          //                   close: e.maxValue,
                          //                 },
                          //               };
                          //             });
                          //           }}
                          //           style={{
                          //             border: "none",
                          //             boxShadow: "none",
                          //             background: "#F7F8FB",
                          //             padding: "20px 20px",
                          //           }}
                          //           labels={["", ""]}
                          //           ruler={false}
                          //           barLeftColor="#F7F8FB"
                          //           barInnerColor="#563BFF"
                          //           barRightColor="#F7F8FB"
                          //           thumbLeftColor="white"
                          //           thumbRightColor="white"
                          //         />
                          //       </Col>
                          //     </Row>
                          //   </Col>
                          // )
                        )}
                      </Row>
                    </FormGroup>
                  </Row>
                </div>
              </Col>
            </Row>
          </div>

          <div
            className="ressources"
            style={{
              marginBottom: "20px",
              marginTop: "20px",
              borderRadius: "10px",
              background: "#FFF",
              border: "1px solid rgb(233, 236, 239)",
              padding: "20px"
            }}
          >
            <h4
              className="section-title font-primary mb-0"
              style={{ fontSize: "18px" }}
            >
              {props.t("Catégories Autorisées")}
            </h4>
            <div
              className="stepSubTitle font-primary"
              style={{ fontSize: "14px" }}
            >
              {props.t("general_subtitle_2")}
            </div>

            <div className="mt-4">
              <div
                className="d-flex flex-wrap align-items-center font-primary gap-2 p-2"
                style={{
                  backgroundColor: "#fff",
                  position: "relative",
                  width: "100%",
                  borderRadius: "10px",
                  border: "1px solid #563BFF",
                  zIndex: "1",
                  cursor: "pointer",
                  fontSize: "14px",
                  minHeight: "42px"
                }}
              >
                {selectedTagNameList.map((element, index) => (
                  <div
                    key={index}
                    className="font-primary d-flex align-items-center gap-1"
                    style={{
                      position: "relative",
                      borderRadius: "8.531px",
                      background: "#563BFF",
                      height: "34.123px",
                      padding: "9px 30px",
                      textAlign: "center",
                      color: "#FFF",
                      fontSize: "14px",
                      fontStyle: "normal",
                      fontWeight: "600",
                      lineHeight: "normal"
                    }}
                    onClick={() => removeItem(index, element)}
                  >
                    {props.t(element)}
                    <MdiInformationVariantCircle
                      id={"TooltipWithHtmlU" + index}
                      width={"18px"}
                      height={"18px"}
                      style={{ cursor: "default" }}
                    />
                    <UncontrolledTooltip
                      innerClassName="font-primary"
                      placement="top"
                      target={"TooltipWithHtmlU" + index}
                    >
                      {props.t(tagDescriptions[element])}
                    </UncontrolledTooltip>
                    <span
                      style={{
                        position: "absolute",
                        top: "0",
                        right: "0",
                        boxShadow:
                          "0px 2.795698881149292px 5.591397762298584px #563BFF",
                        transform: "translate(40%,-40%)",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        width: "13.978px",
                        height: "13.978px",
                        borderRadius: "50%",
                        backgroundColor: "#fff"
                      }}
                    >
                      {svgs.close_icon}
                    </span>
                  </div>
                ))}
              </div>

              {selectedTagNameList.length <= tagsList.length && (
                <div
                  className="tags-card"
                  style={{
                    marginTop: "10px",
                    paddingTop: "30px"
                  }}
                >
                  <div>
                    <span
                      className="font-tertiary font-primary"
                      style={{
                        color: "#666969",
                        fontSize: "14px",
                        fontStyle: "normal",
                        fontWeight: "400",
                        lineHeight: "normal"
                      }}
                    >
                      {props.t("Catégories suggérées")}
                    </span>
                    <div
                      className="mt-2 font-primary d-flex p-2"
                      style={{
                        flexWrap: "wrap",
                        borderRadius: "10px",
                        border: "1px solid #563BFF",
                        rowGap: "10px"
                      }}
                    >
                      {tagsList.map(
                        (tag, index) =>
                          !selectedTagNameList.includes(tag.Name) && (
                            <div key={tag.ID} style={{ cursor: "pointer" }}>
                              <span
                                className={`${
                                  expandedItems.includes(tag.Name)
                                    ? "selected-tag"
                                    : "tag-not-selected-white"
                                } d-flex align-items-center gap-1`}
                                style={{
                                  fontSize: "14px",
                                  position: "relative"
                                }}
                                onClick={() => toggleItem(index, tag)}
                              >
                                {props.t(tag.Name)}
                                <span
                                  style={{
                                    position: "absolute",
                                    top: "0",
                                    right: "0",
                                    boxShadow:
                                      "0px 2.795698881149292px 5.591397762298584px #563BFF",
                                    transform: "translate(40%,-40%)",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    width: "13.978px",
                                    height: "13.978px",
                                    borderRadius: "50%",
                                    backgroundColor: "#fff"
                                  }}
                                >
                                  +
                                </span>
                                <MdiInformationVariantCircle
                                  id={"TooltipWithHtml" + index}
                                  width={"18px"}
                                  height={"18px"}
                                  style={{ cursor: "default" }}
                                />
                              </span>
                              <Tooltip
                                innerClassName="font-primary"
                                placement="top"
                                isOpen={tooltip === "TooltipWithHtml" + index}
                                target={"TooltipWithHtml" + index}
                                toggle={() => {
                                  if (tooltip === "TooltipWithHtml" + index) {
                                    setTooltip(false);
                                  } else {
                                    setTooltip("TooltipWithHtml" + index);
                                  }
                                }}
                              >
                                {props.t(tagDescriptions[tag.Name])}
                              </Tooltip>
                            </div>
                          )
                      )}
                      <div style={{ cursor: "pointer" }}>
                        <span
                          className={`tag-not-selected-white d-flex align-items-center gap-1`}
                          style={{ fontSize: "14px", position: "relative" }}
                        >
                          {props.t("Others")}
                          <MdiInformationVariantCircle
                            id={"TooltipWithHtml999"}
                            width={"18px"}
                            height={"18px"}
                            style={{ cursor: "default" }}
                          />
                        </span>
                        <UncontrolledTooltip
                          innerClassName="font-primary"
                          placement="top"
                          target={"TooltipWithHtml999"}
                        >
                          {props.t("others_description")}
                        </UncontrolledTooltip>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>

          <div
            className="ressources"
            style={{
              marginBottom: "20px",
              marginTop: "20px",
              borderRadius: "10px",
              background: "#FFF",
              border: "1px solid rgb(233, 236, 239)",
              padding: "20px"
            }}
          >
            <Row className="align-items-center justify-content-between flex-row mb-4">
              <div style={{ width: "fit-content" }}>
                <h4
                  className="section-title font-primary mb-0"
                  style={{ fontSize: "18px" }}
                >
                  {props.t("agent_subtitle_2")}
                </h4>
              </div>
            </Row>
            <Row className="mt-3">
              <Col>
                {aiBehaviorData.map((aibehavior, index) => (
                  <Card
                    key={aibehavior.title}
                    className="notifications_item"
                    style={{
                      border: "1px solid rgb(233, 236, 239)"
                    }}
                  >
                    <CardBody className="d-flex align-items-center justify-content-between gap-3">
                      <div className="d-flex flex-column">
                        <div className="d-flex gap-2 align-items-center">
                          <div
                            className="notifications_title font-primary"
                            style={{
                              fontSize: "14px",
                              fontWeight: "700"
                            }}
                          >
                            {props.t(aibehavior.title)}
                          </div>
                        </div>
                        <p
                          className="notifications_teaser mt-2 mb-0"
                          style={{ fontSize: "14px" }}
                        >
                          {props.t(aibehavior.description)}
                        </p>
                      </div>

                      <MyCustomSwitch
                        onClickHandle={handleSwitchAiBehavior}
                        notification_key={aibehavior.key}
                        notification_state={ai_behavior[aibehavior.key]}
                      />
                    </CardBody>
                  </Card>
                ))}
              </Col>
            </Row>
          </div>

          <div
            style={{ textAlign: "end", marginTop: "8px", marginBottom: "40px" }}
          >
            <button
              type="button"
              className="view-button d-flex align-items-center ressouceAdd-button ml-auto"
              style={{
                marginTop: "10px",
                marginLeft: "auto",

                backgroundColor: "#563BFF"
              }}
              disabled={updateAgentLoading || ressources_data_loading}
              onClick={() => {
                if (
                  maaiaNames.length > 0 &&
                  selectedAgentLanguages.length > 0
                ) {
                  handleModalAgentUpdate();
                } else {
                  setNameInputTouched(true);
                }
                updateRessources();
              }}
            >
              {updateAgentLoading || ressources_data_loading ? (
                <div style={{ textAlign: "center", fontSize: "14px" }}>
                  <Spinner
                    className="me-1"
                    style={{ height: "15px", width: "15px" }}
                    animation="border"
                  />
                  {props.t("Enregistrer")}
                </div>
              ) : (
                props.t("Enregistrer")
              )}
            </button>
          </div>
        </div>
      ) : (
        <div style={{ textAlign: "center", fontSize: "14px" }}>
          <Spinner
            className="me-1"
            style={{ height: "15px", width: "15px" }}
            animation="border"
          />
          {props.t("Chargement") + "..."}
        </div>
      )}

      <CalculatorModal
        isOpen={show_calculator}
        toggle={onShowCalculator}
        upgrade_downgrade={true}
      />
    </div>
  );
};

export default withTranslation()(MaaiaPage);
